{
  "auth": {
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "loginTitle": "Bienvenido de nuevo",
    "loginSubtitle": "Ingresa tu usuario o email y la contraseña del panel",
    "loginIdentifier": "Usuario o email",
    "loginIdentifierPlaceholder": "admin o admin{'@'}tudominio.com",
    "systemDescription": "Sistema moderno y eficiente de gestión de cuentas SSH/V2Ray",
    "email": "Correo electrónico",
    "emailPlaceholder": "admin{'@'}tudominio.com",
    "username": "Usuario",
    "password": "Contraseña",
    "rememberMe": "Recuérdame",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "loginButton": "Iniciar Sesión",
    "loggingIn": "Iniciando sesión...",
    "loginSuccess": "¡Inicio de sesión exitoso!",
    "loginError": "Error al iniciar sesión",
    "invalidCredentials": "Usuario o contraseña incorrectos",
    "tooManyAttempts": "Demasiados intentos de inicio de sesión. Intenta de nuevo en unos minutos.",
    "sessionExpired": "Sesión expirada. Por favor, inicia sesión nuevamente.",
    "contactAdmin": "Contacta al administrador para recuperar tu contraseña",
    "impersonate": {
      "banner": "Visualizando como: {username} ({role})",
      "stopAdmin": "Volver al Admin",
      "stopReseller": "Volver a mi cuenta"
    },
    "passwordPlaceholder": "Ingrese su contraseña",
    "sessionExpiration": {
      "title": "Sesión por expirar",
      "message": "Su sesión expirará por inactividad pronto. Haga clic en \"Continuar conectado\" para permanecer conectado.",
      "timeRemaining": "Tiempo restante de inactividad",
      "tip": "Haga clic en \"Continuar conectado\" para renovar ahora.",
      "logoutNow": "Salir ahora",
      "extending": "Renovando...",
      "stayConnected": "Continuar conectado",
      "refreshFailed": "No se pudo renovar la sesión. Inicie sesión de nuevo o inténtelo otra vez."
    }
  },
  "accounts": {
    "title": "Gestionar Cuentas",
    "subtitle": "Gestiona todas las cuentas SSH y V2Ray",
    "createTest": "Crear Prueba",
    "createAccount": "Crear Cuenta",
    "createTestShort": "Prueba",
    "createAccountShort": "Nueva",
    "deleteSelectedShort": "Eliminar",
    "selectAll": "Seleccionar Todas",
    "deleteSelected": "Eliminar Seleccionadas",
    "totalAccounts": "Total de Cuentas",
    "activeAccounts": "Cuentas Activas",
    "expiredAccounts": "Cuentas Expiradas",
    "testAccounts": "Cuentas de Prueba",
    "searchPlaceholder": "Buscar por nombre de usuario o UUID...",
    "allTypes": "Todos los tipos",
    "onlySSH": "Solo SSH",
    "onlyV2Ray": "Solo V2Ray",
    "sshAndV2Ray": "SSH + V2Ray",
    "allStatus": "Todos los estados",
    "active": "Activo",
    "inactive": "Inactivo",
    "expired": "Expirado",
    "test": "Prueba",
    "allCreatorTypes": "Todos los tipos",
    "admins": "Admins",
    "resellersFilter": "Revendedores",
    "allOnline": "Todos",
    "onlyOnline": "Solo en línea",
    "onlyOffline": "Solo desconectados",
    "specificCreator": "Creador específico",
    "searchCreator": "Buscar creador...",
    "noCreatorsFound": "Ningún creador encontrado",
    "allCreators": "Todos los creadores",
    "roleSuperAdmin": "Super Admin",
    "roleAdmin": "Admin",
    "roleReseller": "Revendedor",
    "accounts_count": "cuentas",
    "username": "Nombre de Usuario",
    "category": "Categoría",
    "type": "Tipo",
    "connections": "Conexiones",
    "expiration": "Expiración",
    "status": "Estado",
    "actions": "Acciones",
    "noAccountsFound": "No se encontraron cuentas",
    "expires": "Expira",
    "expiresIn": "Expira en {time}",
    "expiresTomorrow": "Expira mañana",
    "expiresInDays": "{days}d restantes",
    "expiresInHours": "{hours}h restantes",
    "ssh": "SSH",
    "v2ray": "V2Ray",
    "combo": "SSH + V2Ray",
    "enable": "Activar",
    "disable": "Desactivar",
    "edit": "Editar",
    "renew": "Renovar",
    "clearDevices": "Limpiar Dispositivos",
    "delete": "Eliminar",
    "deleteConfirm": {
      "titleOne": "¿Eliminar cuenta?",
      "titleMany": "¿Eliminar {count} cuenta(s)?",
      "warning": "¡ATENCIÓN! Esta acción es IRREVERSIBLE.",
      "questionOne": "¿Realmente desea ELIMINAR la cuenta \"{username}\"?",
      "questionMany": "¿Realmente desea ELIMINAR {count} cuenta(s)?",
      "moreCount": " y {count} más",
      "bulletDbOne": "Se eliminará de la base de datos",
      "bulletDbMany": "Se eliminarán de la base de datos",
      "bulletServersOne": "Se eliminará de todos los servidores",
      "bulletServersMany": "Se eliminarán de todos los servidores",
      "bulletDevices": "Se limpiarán todos los dispositivos",
      "finalWarning": "¡Esta acción NO se puede deshacer!"
    },
    "createModal": {
      "title": "Crear Nueva Cuenta",
      "manual": "Manual",
      "byPlan": "Por Plan",
      "selectPlan": "Seleccione un Plan",
      "choosePlan": "Elija un plan",
      "days": "días",
      "selectCategory": "Seleccione una categoría",
      "servers": "servidor",
      "serversPlural": "servidores",
      "planDetails": "Detalles del Plan",
      "planType": "Tipo",
      "validity": "Validez",
      "connectionLimit": "Límite de Conexiones",
      "usernameLabel": "Nombre de Usuario",
      "usernamePlaceholder": "Nombre de usuario",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Contraseña del usuario",
      "generateRandom": "Generar credenciales aleatorias",
      "categoryLabel": "Categoría",
      "accountType": "Tipo de Cuenta",
      "expirationDays": "Días de Validez",
      "daysPlaceholder": "Ej: 30",
      "createButton": "Crear Cuenta",
      "creating": "Creando...",
      "summary": "Resumen:",
      "summaryType": "Tipo:",
      "summaryUsername": "Usuario:",
      "summaryValidity": "Validez:",
      "summaryExpires": "Expira en:",
      "summaryCategory": "Categoría:",
      "summaryServers": "Se creará en {count} servidor(es)",
      "usernamePlaceholderManual": "Ej: usuario123",
      "passwordPlaceholderManual": "Ej: contraseña123",
      "sshOnly": "Solo SSH",
      "v2rayOnly": "Solo V2Ray",
      "sshV2ray": "SSH + V2Ray",
      "uuidAutoGenerate": "UUID: Se generará automáticamente por el sistema",
      "autoCredentialsInfo": "Credenciales Automáticas: Usuario y contraseña se generarán automáticamente",
      "selectCategoryPlaceholder": "Seleccione una categoría",
      "selectCategoryError": "Seleccione una categoría",
      "resellerCredits": "Créditos disponibles",
      "resellerSlots": "Slots disponibles",
      "resellerSlotsUsed": "{used} slot(s) en uso",
      "emailLabel": "Email",
      "emailPlaceholder": "cliente{'@'}email.com",
      "whatsappLabel": "WhatsApp",
      "whatsappPlaceholder": "+5511999999999",
      "telegramLabel": "Telegram",
      "telegramPlaceholder": "{'@'}usuario o ID",
      "categoryInheritedHint": "Categoría vinculada al revendedor (heredada automáticamente)",
      "unlimited": "Ilimitado",
      "generateUsername": "Generar usuario",
      "generatePassword": "Generar contraseña",
      "validityDaysRange": "Mínimo: {min} días. Máximo: 3650 días (10 años)",
      "buttonTooltips": {
        "saving": "Guardando...",
        "selectPlan": "Seleccione un plan",
        "selectCategory": "Seleccione una categoría",
        "insufficientCredits": "Créditos insuficientes. Necesario: {needed}, Disponible: {available}"
      }
    },
    "testModal": {
      "title": "Crear Cuenta de Prueba",
      "categoryLabel": "Categoría",
      "categoryInherited": "Categoría heredada de su revendedor",
      "serversInCategory": "{count} servidor(es) en la categoría seleccionada",
      "usernameLabel": "Nombre de Usuario",
      "usernameHelp": "3-32 caracteres, solo letras y números",
      "passwordLabel": "Contraseña",
      "passwordHelp": "Mínimo 6 caracteres",
      "durationLabel": "Duración (horas)",
      "durationPlaceholder": "Ej: 2",
      "maxDuration": "Máximo: {max} horas",
      "includeV2ray": "Incluir V2Ray en la prueba",
      "testSummary": "Resumen de la Prueba:",
      "summaryType": "Tipo",
      "summaryValidity": "Validez",
      "summaryCategory": "Categoría",
      "summaryServers": "Se creará en {count} servidor(es)",
      "hours": "horas",
      "createButton": "Crear Prueba",
      "creating": "Creando...",
      "hour": "hora",
      "usernamePlaceholder": "Ej: prueba123",
      "passwordPlaceholder": "Ej: clave123",
      "generateUsername": "Generar usuario aleatorio",
      "generatePassword": "Generar contraseña aleatoria"
    },
    "editAccount": "Editar Cuenta",
    "connectionLimit": "Límite",
    "statusActive": "Activa",
    "statusInactive": "Inactiva",
    "createdBy": "Creado por",
    "currentPassword": "Contraseña Actual",
    "naV2ray": "N/D (V2Ray)",
    "actionTooltips": {
      "enable": "Activar",
      "disable": "Desactivar",
      "renewExpired": "Renovar para reactivar",
      "renew": "Renovar",
      "copyCredentials": "Copiar credenciales",
      "edit": "Editar",
      "clearDevices": "Limpiar Dispositivos",
      "delete": "Eliminar"
    },
    "toggleConfirm": {
      "enableTitle": "¿Activar cuenta?",
      "disableTitle": "¿Desactivar cuenta?",
      "enableMessage": "¿Desea activar la cuenta \"{username}\"?",
      "disableMessage": "¿Desea desactivar la cuenta \"{username}\"?"
    },
    "expiryLabels": {
      "expired": "Expirada",
      "expiresToday": "Expira hoy",
      "expiresTomorrow": "Expira mañana",
      "expiresInDays": "Expira en {days} días",
      "expiresInHours": "Expira en {hours}h",
      "minutesRemaining": "{minutes} minuto(s) restante(s)",
      "hoursRemaining": "{hours} hora(s) restante(s)",
      "daysRemaining": "{days} días restantes"
    },
    "clearDevicesConfirm": {
      "title": "¿Limpiar Dispositivos?",
      "message": "¿Limpiar todos los dispositivos registrados para \"{username}\"?\n\nEsto permitirá que el usuario registre nuevos dispositivos."
    },
    "editModal": {
      "accountInfo": "Información de la Cuenta",
      "copyUsername": "Copiar usuario",
      "togglePassword": "Mostrar/ocultar contraseña",
      "copyPassword": "Copiar contraseña",
      "copyUuid": "Copiar UUID",
      "uuidNotGenerated": "No generado",
      "resellerCreditTitle": "Modo Revendedor Crédito",
      "resellerCreditHint": "Puede editar la contraseña y WhatsApp. Otros campos son solo lectura.",
      "editFields": "Editar Campos",
      "categoryMigrationHint": "Al cambiar de categoría, la cuenta se migrará a los servidores de la nueva categoría",
      "newPassword": "Nueva Contraseña",
      "passwordKeepPlaceholder": "Deje vacío para mantener la contraseña actual",
      "passwordKeepHint": "Deje en blanco para no cambiar",
      "expirationDate": "Fecha de Expiración",
      "saveChanges": "Guardar Cambios",
      "expiryPastWarning": "Fecha pasada — la cuenta quedará expirada",
      "expiryInDays": "Expira en {days} día(s)"
    },
    "renewModal": {
      "title": "Renovar Cuenta",
      "accountLabel": "Cuenta:",
      "typeLabel": "Tipo:",
      "expiresLabel": "Expira:",
      "addDays": "Agregar Días",
      "addDaysHint": "Agregar días a la fecha de expiración actual",
      "addMonths": "Agregar Validez (meses)",
      "monthOption": "{months} mes(es) ({days} días) - {credits} crédito(s)",
      "addDaysPreview": "Agregar {days} días a la validez actual",
      "creditsAvailable": "Créditos disponibles:",
      "creditsInsufficientShort": "¡Créditos insuficientes!",
      "newExpiryLabel": "Nueva fecha de expiración:",
      "daysAdded": "(+{days} día(s))",
      "creditsSufficient": "Créditos Suficientes",
      "creditsInsufficient": "¡Créditos Insuficientes!",
      "creditsAvailableLabel": "Créditos Disponibles:",
      "creditsNeededLabel": "Créditos Necesarios:",
      "balanceAfterRenewal": "Saldo Después de Renovar:",
      "creditsMissing": "¡Faltan {count} créditos!",
      "syncWarning": "Atención: La renovación se sincronizará automáticamente con todos los servidores de la categoría.",
      "renewing": "Renovando...",
      "submit": "Renovar Cuenta",
      "insufficientCredits": "¡Créditos insuficientes! Tiene {available}, necesita {needed}",
      "insufficientCreditsTooltip": "Créditos insuficientes"
    },
    "resultModal": {
      "title": "Cuenta creada con éxito",
      "serversCount": "{count} servidor(es) · {category}",
      "provisioningPendingTitle": "Sincronización en curso.",
      "provisioningPendingBody": " La cuenta ya fue creada en el panel. Los servidores se actualizarán en segundo plano — si alguno está offline, el administrador será notificado.",
      "validityDays": "{days} días",
      "validityLabel": "Validez",
      "expiresAtLabel": "Expira el",
      "categoryLabel": "Categoría",
      "serversLabel": "Servidores",
      "planLabel": "Plan",
      "connectionLimitLabel": "Límite de conexiones",
      "connectionLimitValue": "{limit} dispositivo(s)",
      "createdModePlan": "Por plan",
      "createdModeManual": "Manual",
      "copyHint": "Copie los datos abajo o envíe el mensaje listo por WhatsApp/Telegram."
    },
    "testResultModal": {
      "title": "Cuenta de prueba creada",
      "badge": "Cuenta de prueba",
      "validityHours": "{hours} hora(s)"
    },
    "deletePlanModal": {
      "title": "Eliminar Plan",
      "question": "¿Está seguro de que desea eliminar el plan",
      "cannotUndo": "Esta acción no se puede deshacer."
    }
  },
  "servers": {
    "title": "Gestionar Servidores",
    "addServer": "Añadir Servidor",
    "addServerShort": "Servidor",
    "editServer": "Editar Servidor",
    "deleteServer": "Eliminar Servidor",
    "serverName": "Nombre del Servidor",
    "host": "Host/IP",
    "sshPort": "Puerto SSH",
    "sshUser": "Usuario SSH",
    "sshPassword": "Contraseña SSH",
    "userLimit": "Límite de Usuarios",
    "category": "Categoría",
    "installAPI": "Instalar API",
    "uninstallAPI": "Desinstalar API",
    "checkStatus": "Verificar Estado",
    "apiInstalled": "API Instalada",
    "apiNotInstalled": "API No Instalada",
    "apiError": "Error en API",
    "testConnection": "Probar Conexión",
    "connectionSuccess": "¡Conexión exitosa!",
    "connectionFailed": "Conexión fallida",
    "serverCreated": "¡Servidor creado con éxito!",
    "serverUpdated": "¡Servidor actualizado con éxito!",
    "serverDeleted": "¡Servidor eliminado con éxito!",
    "confirmDelete": "¿Está seguro de que desea eliminar este servidor?",
    "subtitle": "Gestiona todos los servidores SSH y V2Ray",
    "totalServers": "Total de Servidores",
    "activeServers": "Servidores Activos",
    "installedApis": "APIs Instaladas",
    "cpuCores": "{count} núcleos",
    "reinstallApi": "Reinstalar API",
    "edit": "Editar",
    "syncLabel": "Sincronizar",
    "noServersFound": "No se encontraron servidores",
    "sync": {
      "syncing": "Sincronizando...",
      "startedTitle": "Sincronización iniciada",
      "startedMessage": "La sincronización de «{name}» ha comenzado. Se le notificará cuando termine.",
      "completedTitle": "Sincronización completada",
      "completedWithErrorsTitle": "Sincronización con errores",
      "completedPartialTitle": "Sincronización con reservas",
      "errorTitle": "Error en la sincronización",
      "errorGeneric": "No se pudo sincronizar el servidor",
      "startFailed": "No se pudo iniciar la sincronización",
      "startUncertain": "La solicitud tardó demasiado, pero la sincronización puede haberse iniciado. Espere la notificación.",
      "startFailedTitle": "Error en la sincronización",
      "slowTitle": "Sincronización prolongada",
      "slowMessage": "La sincronización sigue en curso. Revise las notificaciones en breve.",
      "notificationBody": "Servidor «{server}»: {summary}",
      "notificationFailed": "Servidor «{server}»: {error}",
      "bellCompleted": "Sincronización completada",
      "bellPartial": "Sincronización completada con reservas",
      "bellWithErrors": "Sincronización con errores",
      "bellError": "Error en la sincronización",
      "resultEligible": "📤 {count} enviada(s) a la API",
      "resultAccountsProcessed": "📋 {count} cuenta(s) procesada(s)",
      "resultSshSent": "🔐 {count} SSH a la API",
      "resultV2raySent": "📡 {count} V2Ray a la API",
      "resultNoneEligible": "Ninguna cuenta activa elegible para sincronizar",
      "resultSynced": "✅ {count} OK (todos los protocolos)",
      "resultPartial": "⚠️ {count} parcial (SSH o V2Ray)",
      "resultPartialOk": "✓ {count} OK en parte de protocolos",
      "resultApiRejected": "❌ {count} rechazada(s) por la API",
      "resultSkippedHeader": "Omitidas: {list}",
      "resultCategoryTotal": "📊 {count} en la categoría",
      "resultExpired": "⏰ {count} expirada(s)",
      "resultInactive": "🔒 {count} inactiva(s)",
      "resultInvalid": "⚠️ {count} sin credencial válida",
      "resultReseller": "🚫 {count} revendedor inactivo/expirado",
      "resultFailed": "❌ {count} con error",
      "resultTotal": "📊 Total: {count}",
      "summaryEligible": "{count} enviada(s) a la API",
      "summaryAccountsProcessed": "{count} cuenta(s) procesada(s)",
      "summarySshSent": "{count} SSH a la API",
      "summaryV2raySent": "{count} V2Ray a la API",
      "summaryOutcome": "resultado: {list}",
      "summaryApiOkTotal": "{count} OK ({ssh} SSH + {v2ray} V2Ray)",
      "summaryApiRejectedTotal": "{count} rechazado(s) API",
      "resultAccountsSynced": "✅ {count} cuenta(s) sincronizada(s)",
      "resultAccountsFailed": "❌ {count} cuenta(s) con fallo",
      "summarySynced": "{count} OK",
      "summaryPartial": "{count} parcial",
      "summaryPartialOk": "{count} OK parcial",
      "summaryApiRejected": "{count} rechazada(s) API",
      "summarySkipped": "omitidas: {list}",
      "summaryCategoryTotal": "{count} en la categoría",
      "summaryExpired": "{count} expirada(s) omitida(s)",
      "summaryInactive": "{count} inactiva(s) omitida(s)",
      "summaryInvalid": "{count} sin credencial válida",
      "summaryReseller": "{count} revendedor inactivo/expirado",
      "summaryFailed": "{count} fallo(s) total en la API",
      "summaryTotal": "total {count}"
    },
    "installProgress": {
      "modalTitle": "Instalando API en el Servidor",
      "progressLabel": "Progreso",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "connectingSsh": "Conectando al servidor SSH...",
      "logStarting": "Iniciando instalación de la API...",
      "logConnecting": "Conectando vía SSH...",
      "installSuccess": "¡API instalada con éxito!",
      "adoptedSuccess": "¡API existente vinculada y binario actualizado!",
      "failedToast": "La instalación de la API falló. Revise los registros.",
      "sshAuthFailed": "Error de autenticación SSH. Verifique usuario y contraseña del servidor.",
      "sshConnectionFailed": "No se pudo conectar al servidor. Verifique host, puerto SSH y firewall.",
      "completedMessage": "¡Instalación completada con éxito!",
      "apiRespondingOnPort": "API respondiendo en el puerto {port}",
      "waiting_start": "Esperando inicio...",
      "checking_existing": "Verificando instalación existente...",
      "existing_detected": "API existente detectada — preservando clave, puerto {port} y actualizando solo el binario",
      "services_stopped": "Servicio(s) anterior(es) detenido(s): {names}",
      "detecting_architecture": "Detectando arquitectura...",
      "binary_selected": "Binario: {binaryName} (GitHub Releases)",
      "creating_directories": "Creando directorios...",
      "downloading_binary": "Descargando binario de GitHub (panel)...",
      "uploading_binary": "Enviando binario al servidor vía SFTP...",
      "binary_downloaded": "Binario implantado ({sizeMb} MB)",
      "binary_path_resolved": "Ruta del binario en el servidor: {path}",
      "binary_deployed": "Binario reemplazado en {path} ({sizeMb} MB)",
      "binary_upload_failed": "Error al enviar el binario al servidor vía SFTP.",
      "binary_upload_size_mismatch": "Binario enviado incompleto (local: {local} bytes, remoto: {remote} bytes).",
      "keeping_systemd": "Manteniendo unit systemd existente (clave y puerto preservados)",
      "configuring_systemd": "Configurando systemd...",
      "reloading_systemd": "Recargando systemd...",
      "enabling_service": "Habilitando servicio...",
      "starting_service": "Iniciando servicio...",
      "checking_status": "Verificando estado...",
      "service_active": "¡Servicio VeltrixPanel activo!",
      "testing_api": "Probando API...",
      "api_responding": "API respondiendo (HTTP 200)",
      "completed": "¡Instalación completada!",
      "existing_service_detected": "Instalación existente detectada (VeltrixPanel.service)",
      "existing_key_reused": "La clave existente se reutilizará para mantener compatibilidad con otros paneles",
      "existing_port_reused": "Se reutilizará el puerto existente: {port}",
      "existing_port_not_found": "Instalación existente detectada, pero no se pudo leer el puerto del servicio systemd",
      "services_stopped_ok": "Servicio(s) anterior(es) detenido(s)",
      "arch_detected": "Arquitectura detectada: {arch}",
      "systemd_preserved": "Configuración systemd mantenida — solo binario actualizado",
      "unsupported_architecture": "Arquitectura no soportada: {arch}",
      "binary_download_failed": "Error al descargar binario de GitHub (tamaño: {fileSize} bytes). Verifique la conexión a internet del panel.",
      "service_not_started": "El servicio no inició (estado: {status})",
      "exception": "Error: {message}"
    },
    "noServers": "Ningún servidor",
    "noServersHint": "Agregue su primer servidor para comenzar",
    "loadingMetrics": "Cargando métricas...",
    "online": "En línea",
    "offline": "Desconectado",
    "installApi": "Instalar API",
    "installRestricted": "Instalación restringida a Super Admin",
    "installRestrictedShort": "Restringido",
    "creating": "Creando...",
    "editServerTitle": "Editar Servidor",
    "editServerSubtitle": "Actualice la información del servidor {name}",
    "newSshPassword": "Nueva Contraseña SSH (deje en blanco para mantener la actual)",
    "newSshPasswordPlaceholder": "Ingrese la nueva contraseña SSH (opcional)",
    "defaultCategory": "Predeterminada",
    "noCategoriesWarning": "No hay categorías registradas. Usando categoría predeterminada.",
    "addServerButton": "Agregar Servidor",
    "ssh2ExtensionError": "La extensión SSH2 no está instalada.\n\n{instructions}\n\n{note}",
    "deleteModal": {
      "title": "Eliminar Servidor",
      "confirm": "¿Está seguro de que desea eliminar el servidor {name}?",
      "irreversible": "⚠️ ¡Esta acción no se puede deshacer!",
      "uninstallApiLabel": "Desinstalar API del servidor antes de eliminar",
      "uninstallApiHelp": "Recomendado: Elimina el servicio API del servidor remoto. Desmarque solo si ya no tiene acceso SSH al servidor.",
      "confirmButton": "Sí, Eliminar Servidor"
    },
    "installModal": {
      "title": "Instalar API {panelName}",
      "subtitle": "Configure la instalación de la API en el servidor {name}",
      "apiPortLabel": "Puerto de la API",
      "autoKeyTitle": "API Key Automática",
      "autoKeyHelp": "La API Key se generará automáticamente durante la instalación y se configurará en el servidor. Podrá verla después de completar.",
      "installing": "Instalando..."
    },
    "apiUninstallConfirm": "¿Está seguro de que desea desinstalar la API del servidor \"{name}\"?\n\nEsto detendrá el servicio API de {panelName} en el servidor remoto."
  },
  "categories": {
    "title": "Categorías",
    "subtitle": "Organiza tus servidores en categorías",
    "addCategory": "Nueva Categoría",
    "addCategoryShort": "Categoría",
    "name": "Nombre",
    "servers": "Servidores",
    "accounts": "Cuentas",
    "actions": "Acciones",
    "noCategoriesFound": "No se encontraron categorías",
    "emptyHint": "Cree su primera categoría para organizar servidores y usuarios",
    "defaultBadge": "Predeterminada",
    "users": "Usuarios",
    "setAsDefault": "Definir como Predeterminada",
    "migrate": "Migrar",
    "migrateFrom": "Migrar de: {name}",
    "migrateType": "Tipo",
    "migrateEntityUsers": "Usuarios",
    "migrateEntityServers": "Servidores",
    "migrateEntityResellers": "Revendedores",
    "migrateTargetCategory": "Categoría de Destino",
    "migrateAttention": "¡Atención!",
    "migrating": "Migrando...",
    "confirmMigration": "Confirmar Migración",
    "cannotDeleteDefault": "No se puede eliminar la categoría predeterminada",
    "deleteConfirm": {
      "title": "¿Eliminar categoría?",
      "question": "¿Está seguro de que desea eliminar la categoría \"{name}\"?",
      "finalWarning": "Esta acción no se puede deshacer."
    },
    "migrateWarnings": {
      "users": "Las cuentas de esta categoría se moverán. Las cuentas vinculadas a revendedores también moverán el revendedor, subrevendedores, cuentas de la jerarquía y la migración en los servidores.",
      "resellers": "Los revendedores de esta categoría se moverán junto con subrevendedores, cuentas de la jerarquía y la migración en los servidores.",
      "servers": "Todos los servidores de esta categoría se moverán a la categoría seleccionada."
    }
  },
  "checkuser": {
    "title": "CheckUser",
    "subtitle": "Gestionar CheckUser para DTunnel y Conecta4G",
    "dtunnelUrl": "URL DTunnel",
    "conectaUrl": "URL Conecta4G",
    "devicePolicyCardTitle": "Dispositivos (DTunnel)",
    "devicePolicyCardSubtitle": "Límite por cuenta y limpieza de registros en un solo bloque.",
    "deviceLimitTitle": "Limitador por dispositivo",
    "deviceLimitDesc": "Si está activo, checkuser registra cada deviceId y devuelve count_connections (total de dispositivos). La app DTunnel lo compara con limit_connections y aplica el límite.",
    "deviceLimitOffHint": "Con el limitador desactivado, checkuser ignora deviceId (no guarda) y devuelve count_connections = 0.",
    "cleanupSectionTitle": "Limpieza automática",
    "cleanupSectionSubtitle": "El worker elimina registros inactivos según el intervalo indicado.",
    "cleanupTotalTitle": "Limpieza total",
    "cleanupTotalDesc": "Elimina todos los dispositivos de todos los usuarios. Úselo solo si conoce el impacto.",
    "inactivityLabel": "Tiempo de inactividad",
    "inactivityHelp": "Los registros sin acceso durante más tiempo pueden eliminarse (limpieza automática o manual).",
    "howItWorksTitle": "Cómo funciona",
    "howItWorksBullet1": "El worker en segundo plano verifica periódicamente.",
    "howItWorksBullet2": "Los dispositivos sin acceso en el período configurado pueden eliminarse.",
    "howItWorksBullet3": "Libera espacio y permite nuevos registros.",
    "howItWorksBullet4": "Las cuentas activas en uso normal no se ven afectadas por el intervalo elegido.",
    "statsTotalDevices": "Dispositivos totales",
    "statsUsersWithDevices": "Usuarios con dispositivos",
    "statsActive24h": "Activos (24 h)",
    "statsUsersAtLimit": "En el límite",
    "lastAutoCleanup": "Última limpieza automática",
    "lastAutoCleanupNever": "Aún no registrada",
    "runCleanupNow": "Ejecutar limpieza ahora",
    "runCleanupRunning": "Ejecutando…",
    "interval1h": "1 hora",
    "interval2h": "2 horas",
    "interval6h": "6 horas",
    "interval12h": "12 horas",
    "interval24h": "24 horas (1 día)",
    "interval48h": "48 horas (2 días)",
    "interval7d": "7 días (1 semana)",
    "deviceCleanup": "Limpieza de Dispositivos",
    "cleanupInterval": "Intervalo de Limpieza",
    "executeNow": "Ejecutar Ahora",
    "runCleanupNow": "Ejecutar Ahora",
    "clearAll": "Limpiar Todos",
    "copyUrl": "Copiar URL",
    "test": "Probar",
    "testing": "Probando...",
    "minutes": "minutos",
    "enabled": "Activado",
    "disabled": "Desactivado",
    "autoCleanup": "La limpieza automática se ejecuta en segundo plano cada {minutes} minutos",
    "confirmClearAll": "¿Limpiar TODOS los Dispositivos?",
    "confirmClearAllDesc": "Esta acción limpiará TODOS los dispositivos de TODOS los usuarios. ¡Esta operación NO se puede deshacer!"
  },
  "backup": {
    "title": "Gestionar Backup",
    "subtitle": "Configura copias de seguridad automáticas vía Telegram",
    "telegramBot": "Bot de Telegram",
    "botToken": "Token del Bot",
    "chatId": "Chat ID",
    "backupPassword": "Contraseña del Backup",
    "interval": "Intervalo",
    "lastBackup": "Último Backup",
    "executeNow": "Hacer Backup Ahora",
    "restoreBackup": "Restaurar Backup",
    "automaticBackup": "Backup Automático",
    "restoreTab": "Restaurar Backup",
    "telegramConfig": "Configuración de Telegram",
    "botTokenPlaceholder": "1234567890:ABCdefGHIjklMNOpqrsTUVwxyz",
    "chatIdPlaceholder": "123456789",
    "backupPasswordPlaceholder": "Contraseña para cifrar el backup",
    "backupInterval": "Intervalo de Backup",
    "selectInterval": "Seleccione el intervalo",
    "everyHour": "Cada 1 hora",
    "every6Hours": "Cada 6 horas",
    "every12Hours": "Cada 12 horas",
    "daily": "Diariamente",
    "saveConfig": "Guardar Configuración",
    "uploadBackup": "Subir Archivo de Backup",
    "selectFile": "Seleccione el archivo .sql.enc",
    "restoreButton": "Restaurar Base de Datos",
    "telegramBackupDesc": "EnvÃ­e copias de seguridad cifradas de la base de datos a Telegram",
    "botTokenLabel": "Token del Bot",
    "createBotHelp": "Crea un bot con",
    "intervalLabel": "Intervalo de Backup",
    "interval1min": "Cada 1 minuto (PRUEBA)",
    "interval5min": "Cada 5 minutos",
    "interval15min": "Cada 15 minutos",
    "interval30min": "Cada 30 minutos",
    "interval1hour": "Cada 1 hora",
    "interval6hours": "Cada 6 horas",
    "interval12hours": "Cada 12 horas",
    "intervalDaily": "Diariamente (24h)",
    "interval2days": "Cada 2 días",
    "intervalWeekly": "Semanalmente (7 días)",
    "intervalHelp": "Valores en minutos. El worker verifica automáticamente y ejecuta en el intervalo configurado.",
    "chatIdHelp": "Use {'@'}userinfobot para obtener su Chat ID",
    "passwordNewPlaceholder": "Ingrese nueva contraseña o deje en blanco para mantener la actual",
    "passwordInitialPlaceholder": "Configure una contraseña de cifrado (mínimo 8 caracteres)",
    "passwordConfiguredStatus": "Contraseña de backup configurada",
    "passwordNotConfiguredStatus": "Configure una contraseña de backup",
    "passwordHelpConfigured": "Deje en blanco para mantener la contraseña actual. Mínimo 8 caracteres si la cambia.",
    "passwordHelpRequired": "Contraseña obligatoria para cifrar el backup. ¡Guárdela de forma segura!",
    "lastAutomaticBackup": "Último Backup Automático",
    "nextBackupIn": "Próximo en ~{minutes} min",
    "howItWorksTitle": "Cómo funciona:",
    "howItWorksItem1": "El worker en segundo plano se ejecuta automáticamente",
    "howItWorksItem2": "La base de datos se cifra con AES-256",
    "howItWorksItem3": "El backup se envía a Telegram",
    "howItWorksItem4": "Guarde su contraseña para restaurar",
    "saveSettings": "Guardar Configuración",
    "manualBackupTitle": "Hacer backup manual ahora",
    "manualBackupDisabledTitle": "Configure la contraseña de backup primero",
    "restoreSubtitle": "Restaure un backup cifrado de la base de datos",
    "selectFileButton": "Seleccionar Archivo",
    "criticalOperationTitle": "⚠️ ATENCIÓN - OPERACIÓN CRÍTICA",
    "criticalOperationItem1": "Esta operación BORRARÁ todos los datos actuales",
    "criticalOperationItem2": "Haga un backup actual antes de restaurar",
    "criticalOperationItem3": "Asegúrese de tener el archivo correcto",
    "criticalOperationItem4": "El sistema estará indisponible durante la restauración",
    "criticalOperationItem5": "Será desconectado después de la restauración",
    "restoreProgressTitle": "Restaurando backup...",
    "restoreProgressWait": "Espere. Esta operación puede tardar unos minutos. No cierre esta página.",
    "confirmRestoreCheckbox": "Entiendo que esta operación BORRARÁ TODOS LOS DATOS ACTUALES y los reemplazará por el backup. Confirmo que hice un backup de la base de datos actual y deseo continuar."
  },
  "logs": {
    "title": "Logs del Sistema",
    "subtitle": "Historial de acciones y eventos del panel",
    "level": "Nivel",
    "message": "Mensaje",
    "date": "Fecha/Hora",
    "action": "Acción",
    "user": "Usuario",
    "ip": "IP",
    "clearOld": "Limpiar Antiguos",
    "clearOldShort": "Limpiar",
    "refresh": "Actualizar",
    "totalLogs": "Total de Logs",
    "last24h": "Últimas 24 h",
    "errors": "Errores",
    "warnings": "Advertencias",
    "info": "Info",
    "filterByLevel": "Filtrar por nivel",
    "allLevels": "Todos los niveles",
    "allActions": "Todas las acciones",
    "error": "Error",
    "warning": "Advertencia",
    "searchLogs": "Buscar en logs...",
    "noLogsFound": "No se encontraron logs",
    "loading": "Cargando...",
    "recordsTitle": "Registros de log",
    "showingRecords": "Mostrando {shown} de {total} registros",
    "lastNLogs": "Últimos {limit} logs",
    "records50": "50 registros",
    "records100": "100 registros",
    "records200": "200 registros",
    "records500": "500 registros",
    "systemUser": "Sistema",
    "confirmClearTitle": "Limpiar logs antiguos",
    "confirmClearBody": "¿Eliminar logs de más de 90 días? Esta acción no se puede deshacer.",
    "details": "Detalles",
    "confirmClearOld": "¿Limpiar logs antiguos (>90 días)?"
  },
  "imageCrop": {
    "title": "Recortar imagen",
    "subtitle": "Ajuste el encuadre. Salida: {width}×{height}px",
    "confirm": "Usar recorte",
    "processing": "Procesando..."
  },
  "profile": {
    "title": "Mi Perfil",
    "subtitle": "Gestiona tu información personal",
    "avatarTitle": "Foto de Perfil",
    "choosePhoto": "Elegir Foto",
    "uploading": "Subiendo...",
    "avatarFormatsHint": "Formatos: JPG, PNG • Hasta {max} MB al elegir • Recorte y compresión automáticos (512×512)",
    "cropAvatarTitle": "Recortar foto de perfil",
    "usernameReadonlyHint": "El nombre de usuario no se puede cambiar",
    "emailReadonlyHint": "El correo no se puede cambiar",
    "role": "Cargo",
    "notAvailable": "N/D",
    "removeAvatarTitle": "¿Eliminar foto de perfil?",
    "changePassword": "Cambiar Contraseña",
    "currentPassword": "Contraseña Actual",
    "newPassword": "Nueva Contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "confirmNewPassword": "Confirmar Nueva Contraseña",
    "currentPasswordPlaceholder": "Ingrese su contraseña actual",
    "newPasswordPlaceholder": "Ingrese la nueva contraseña",
    "confirmPasswordPlaceholder": "Confirme la nueva contraseña",
    "roles": {
      "super_admin": "Super Administrador",
      "admin": "Administrador",
      "reseller": "Revendedor"
    }
  },
  "accountPlans": {
    "title": "Planes de Cuentas",
    "subtitle": "Gestiona los planes disponibles para cuentas",
    "addPlan": "Nuevo Plan",
    "addPlanShort": "Plan",
    "editPlan": "Editar Plan",
    "name": "Nombre del Plan",
    "type": "Tipo",
    "sshOnly": "Solo SSH",
    "v2rayOnly": "Solo V2Ray",
    "both": "SSH + V2Ray",
    "validity": "Validez (días)",
    "validityMonths": "Validez (meses)",
    "connectionLimit": "Límite de Conexiones",
    "price": "Precio",
    "actions": "Acciones",
    "noPlansFound": "No se encontraron planes",
    "createFirstPlan": "Crear primer plan",
    "modalTitle": "Nuevo Plan de Cuenta",
    "modalEditTitle": "Editar Plan de Cuenta",
    "namePlaceholder": "Ej: Plan Premium 30 días",
    "description": "Descripción",
    "descriptionPlaceholder": "Descripción del plan (opcional)",
    "selectType": "Seleccione el tipo",
    "validityPlaceholder": "Ej: 30",
    "connectionLimitPlaceholder": "Ej: 1",
    "connectionLimitMinHelp": "Mínimo: 1 conexión simultánea",
    "planActive": "Plan activo",
    "pricePlaceholder": "Ej: 15.00",
    "createButton": "Crear Plan",
    "saveButton": "Guardar Cambios"
  },
  "resellerPlans": {
    "title": "Planes de Reventa",
    "subtitle": "Gestiona los planes para revendedores",
    "addPlan": "Nuevo Plan",
    "addPlanShort": "Plan",
    "editPlan": "Editar Plan",
    "name": "Nombre del Plan",
    "credit": "Crédito",
    "subscriptionLimit": "Límite de Suscripciones",
    "connectionLimit": "Límite de Conexiones",
    "validity": "Validez (días)",
    "price": "Precio",
    "actions": "Acciones",
    "noPlansFound": "No se encontraron planes",
    "modalTitle": "Nuevo Plan de Reventa",
    "modalEditTitle": "Editar Plan de Reventa",
    "namePlaceholder": "Ej: Plan Revendedor Premium",
    "description": "Descripción",
    "descriptionPlaceholder": "Descripción del plan (opcional)",
    "creditAmount": "Cantidad de Crédito",
    "creditPlaceholder": "Ej: 100",
    "subscriptionLimitPlaceholder": "Ej: 50",
    "connectionLimitPlaceholder": "Ej: 1",
    "validityPlaceholder": "Ej: 30",
    "durationMonths": "Duración (meses)",
    "pricePlaceholder": "Ej: 50.00",
    "createButton": "Crear Plan",
    "saveButton": "Guardar Cambios",
    "total": "Total",
    "creditPlans": "Crédito",
    "subscriptionPlans": "Suscripción",
    "credits": "créditos",
    "typeCredit": "Crédito",
    "typeSubscription": "Suscripción",
    "creditType": "Crédito",
    "subscriptionType": "Suscripción",
    "creditTypeDesc": "Cantidad fija",
    "subscriptionTypeDesc": "Límite de suscripciones",
    "blockedCredit": "🔒 Bloqueado (eres Suscripción)",
    "blockedSubscribe": "🔒 Bloqueado (eres Crédito)",
    "loadingInfo": "⏳ Cargando información...",
    "creditResellerInfo": "ℹ️ Revendedor tipo CRÉDITO solo puede crear planes de CRÉDITO",
    "subscribeResellerInfo": "ℹ️ Revendedor tipo SUSCRIPCIÓN solo puede crear planes de SUSCRIPCIÓN",
    "noPlansMessage": "No hay planes registrados. ¡Crea tu primer plan!",
    "planActive": "Plan activo",
    "durationDays": "Duración (días)",
    "plan": "Plan",
    "type": "Tipo",
    "details": "Detalles",
    "loading": "Cargando...",
    "noPlansFull": "Â¡No hay planes registrados. Crea tu primer plan!",
    "daysLogins": "dÃ­as / logins",
    "active": "Activo",
    "inactive": "Inactivo",
    "deletePlanModal": {
      "title": "Eliminar Plan",
      "question": "¿Está seguro de que desea eliminar el plan",
      "cannotUndo": "Esta acción no se puede deshacer."
    }
  },
  "serverModal": {
    "title": "Agregar Servidor",
    "editTitle": "Editar Servidor",
    "subtitle": "Gestiona todos los servidores SSH y V2Ray",
    "name": "Nombre",
    "namePlaceholder": "Ej: Servidor Principal",
    "host": "Host/IP",
    "hostPlaceholder": "Ej: 192.168.1.1",
    "hostHelp": "Soporta IPv4, IPv6 y hostnames",
    "sshPort": "Puerto SSH",
    "sshPortPlaceholder": "22",
    "sshUser": "Usuario SSH",
    "sshUserPlaceholder": "root",
    "sshPassword": "Contraseña SSH",
    "sshPasswordPlaceholder": "***",
    "sshPasswordWarning": "La contraseña se usará para conectar vía SSH e instalar la API",
    "category": "Categoría",
    "selectCategory": "Seleccione una categoría",
    "addCategory": "Agregar categoría",
    "setDefault": "Establecer como categoría predeterminada",
    "defaultHelp": "La categoría predeterminada se usará cuando no se especifique ninguna",
    "apiPort": "Puerto API",
    "apiPortPlaceholder": "8080",
    "apiPortHelp": "Puerto donde se ejecutará la API (1024-65535)",
    "status": "Estado",
    "active": "Activo",
    "inactive": "Inactivo",
    "cancel": "Cancelar",
    "save": "Guardar",
    "create": "Crear Servidor"
  },
  "categoryModal": {
    "title": "Agregar Categoría",
    "editTitle": "Editar Categoría",
    "name": "Nombre",
    "namePlaceholder": "Ej: Premium",
    "description": "Descripción",
    "descriptionPlaceholder": "Descripción de la categoría",
    "cancel": "Cancelar",
    "save": "Guardar",
    "create": "Crear Categoría"
  },
  "salesLink": {
    "title": "Tu Enlace de Ventas",
    "subtitle": "Comparte con tus clientes",
    "accountSalesLabel": "Ventas de Cuentas SSH/V2Ray",
    "accountSalesHelp": "Los clientes pueden comprar planes de acceso a través de este enlace",
    "resellerSalesLabel": "Ventas de Planes de Reventa",
    "resellerSalesHelp": "Nuevos revendedores pueden registrarse a través de este enlace",
    "renewalLabel": "Renovación de credenciales",
    "renewalHelp": "Los clientes pueden renovar cuentas SSH/V2Ray ingresando username o UUID",
    "linkCopied": "¡Enlace copiado al portapapeles!",
    "copyError": "Error al copiar enlace",
    "salesDisabled": "Ventas automáticas deshabilitadas",
    "salesDisabledHelp": "Activa las ventas automáticas en la configuración para generar tu enlace"
  },
  "automations": {
    "title": "Automatizaciones",
    "subtitle": "Configura automatizaciones e integraciones",
    "paymentGateways": "Pasarelas de Pago",
    "addGateway": "Agregar Pasarela",
    "editGateway": "Editar Pasarela",
    "provider": "Proveedor",
    "region": "Región",
    "accessToken": "Token de Acceso",
    "accessTokenEditPlaceholder": "Deje en blanco para mantener el token actual",
    "accessTokenEditHint": "Por seguridad el token no se muestra. Complételo solo si desea reemplazarlo.",
    "mpAccessTokenStoredHint": "Access Token ya guardado. Complételo solo si desea cambiarlo.",
    "webhookSecretEditPlaceholder": "Deje en blanco para mantener el secret actual",
    "webhookSecretStoredHint": "Webhook Secret ya guardado. Complételo solo si desea cambiarlo.",
    "status": "Estado",
    "actions": "Acciones",
    "noGateways": "No hay pasarelas configuradas",
    "sales": "Ventas Automáticas",
    "activateSales": "Activar Ventas",
    "salesUrl": "URL de Ventas",
    "resellerSales": "Ventas de Reventa",
    "activateResellerSales": "Activar Ventas de Reventa",
    "gateway": "Pasarela",
    "selectProvider": "Seleccione...",
    "mercadoPago": "Mercado Pago",
    "asaas": "Asaas",
    "efiBank": "EFI Bank (Efí Pay)",
    "paypal": "PayPal",
    "regionCountry": "Región / País",
    "cannotChangeProvider": "No se puede cambiar el proveedor después de crear",
    "cannotChangeRegion": "No se puede cambiar la región después de crear",
    "mpCredentials": "Credenciales Mercado Pago",
    "publicKey": "Public Key",
    "publicKeyPlaceholder": "APP_USR-...",
    "testMode": "Modo de Prueba",
    "testModeHelp": "Active para usar credenciales de prueba",
    "managePaymentMethods": "Gestionar Métodos de Pago",
    "paymentMethods": "Métodos de Pago",
    "enabledMethods": "Métodos Habilitados",
    "selectMethods": "Seleccione los métodos que desea aceptar",
    "managePaymentMethodsDesc": "Gestione sus métodos de pago",
    "messageTemplatesTitle": "Plantillas de mensajes",
    "messageTemplatesSubtitle": "Personalice mensajes de cuenta, revendedor, prueba y ventas. Los campos vacíos heredan del master.",
    "messageTemplatesInheritanceHint": "Deje en blanco o use «Restaurar predeterminado» para heredar del master. Solo se guarda lo que personalice.",
    "messageTemplatesSaved": "¡Plantillas guardadas con éxito!",
    "noGatewaysConfigured": "Ningún gateway de pago configurado",
    "configureGatewayFirst": "Configure primero un gateway de pago",
    "salesWarning": "Para activar ventas y reventas automáticas, agregue al menos un gateway de pago arriba (Mercado Pago, Asaas o PayPal).",
    "salesSettingsTitle": "Configuración de ventas",
    "salesCategoryLabel": "Categoría para ventas",
    "accountSalesCategoryLabel": "Categoría para ventas de cuentas",
    "resellerSalesCategoryLabel": "Categoría para ventas de revendedores",
    "salesCategoryAdminHelp": "Define la categoría usada en las ventas automáticas. Aplica a cuentas y revendedores.",
    "salesCategoryResellerHelp": "La categoría se hereda de su registro de revendedor y no puede cambiarse aquí.",
    "selectSalesCategory": "Seleccione una categoría",
    "selectSalesCategoryFirst": "Seleccione una categoría en esta tarjeta antes de activar.",
    "salesCategorySaved": "Categoría de ventas guardada con éxito",
    "howToConfigure": "📌 Cómo Configurar",
    "mpStep1": "Acceda: Mercado Pago Developers",
    "mpStep2": "Vaya a \"Sus integraciones\" → \"Credenciales\"",
    "mpStep3": "Copie el \"Access Token\" de producción y péguelo arriba",
    "mpStep4": "Configure el webhook en Mercado Pago con la URL proporcionada",
    "mpStep5": "Active las ventas deseadas",
    "mpStep6": "¡Comparta la URL pública con sus clientes!",
    "setDefaultGateway": "Establecer como pasarela predeterminada",
    "defaultGatewayHelp": "La pasarela predeterminada se mostrará primero a los clientes",
    "addFirstGateway": "Agregar Primer Gateway",
    "configurePaymentMethods": "Configurar Métodos",
    "paymentMethods": "Métodos de Pago",
    "selectPaymentMethodsDesc": "Selecciona qué métodos de pago deseas ofrecer a tus clientes",
    "methodsSelected": "métodos seleccionados",
    "noPaymentMethodsAvailable": "No hay métodos de pago disponibles para esta región",
    "paymentMethodsUpdated": "Métodos de pago actualizados con éxito",
    "asaasCredentials": "Credenciales Asaas",
    "asaasEnvironment": "Entorno",
    "asaasEnvironmentProduction": "Producción",
    "asaasEnvironmentSandbox": "Sandbox",
    "asaasEnvironmentHelp": "Sandbox: clave $aact_hmlg_... en api-sandbox.asaas.com. Producción: clave $aact_prod_... en api.asaas.com. No mezcle clave y entorno.",
    "asaasApiKey": "API Key",
    "asaasApiKeyPlaceholder": "pega tu API key de Asaas ($aact_hmlg_... o $aact_prod_...)",
    "asaasApiKeyEditPlaceholder": "deja en blanco para mantener la clave actual",
    "asaasApiKeyHelp": "Genérela en Asaas → Integraciones → API. No pegues aquí la URL del webhook del panel.",
    "asaasApiKeyStoredHint": "Clave API ya guardada. Complétala solo si quieres cambiarla.",
    "asaasWebhookToken": "Token del Webhook",
    "asaasWebhookTokenPlaceholder": "opcional, define el mismo token en Asaas",
    "asaasWebhookTokenHelp": "Este token valida que las notificaciones provienen de Asaas.",
    "asaasWebhookDescription": "Configura esta URL en Asaas → Mi cuenta → Integraciones → Webhooks para recibir notificaciones de pago.",
    "asaasWebhookTokenRequiredHint": "En Asaas, usa el mismo token arriba como «Token de autenticación». Asaas lo envía en el header asaas-access-token. La URL debe ser pública (ngrok/dominio) — localhost no recibe webhooks.",
    "pixEvpKey": "Clave PIX (EVP)",
    "pixEvpKeyPlaceholder": "ej: 123e4567-e89b-12d3-a456-426614174000",
    "pixEvpKeyHelp": "Registra esta clave EVP en el panel Asaas (Pix → Claves). La API v3 no envía la clave por cobro; debe existir en la cuenta.",
    "asaasPixOnly": "Asaas actualmente ofrece sólo PIX. La selección se mantiene fija para proteger el flujo.",
    "efiCredentials": "Credenciales EFI Bank",
    "efiEnvironment": "Entorno",
    "efiEnvironmentProduction": "Producción",
    "efiEnvironmentSandbox": "Homologación",
    "efiEnvironmentHelp": "Use Homologación para pruebas. Producción requiere certificado de producción.",
    "efiClientIdPlaceholder": "Client_Id de la aplicación PIX en Efí",
    "efiClientIdStoredHint": "Client_Id ya guardado. Complete solo para cambiarlo.",
    "efiClientSecretPlaceholder": "Client_Secret de la aplicación",
    "efiClientSecretEditPlaceholder": "deje en blanco para mantener el secret actual",
    "efiCertificateP12": "Certificado .p12 / .pfx",
    "efiCertificateSelected": "Archivo seleccionado: {name}",
    "efiCertificateStoredHint": "Certificado ya guardado. Suba otro archivo solo si desea reemplazarlo.",
    "efiCertificateHelp": "Suba el certificado PFX (.p12) descargado en Efí → API → Mis Certificados. La API exige mTLS en todas las solicitudes (OAuth + Pix).",
    "efiCertificatePassphrase": "Contraseña del certificado",
    "efiCertificatePassphrasePlaceholder": "deje vacío si el .p12 no tiene contraseña",
    "efiCertificatePassphraseHelp": "Algunos certificados Efí están protegidos por contraseña. Si no tiene contraseña, deje en blanco.",
    "efiCertificateInvalidExtension": "Seleccione un archivo .p12 o .pfx válido.",
    "efiCertificateReadError": "No se pudo leer el archivo del certificado.",
    "efiPixKeyHelp": "Clave PIX aleatoria (EVP) registrada en Efí.",
    "efiWebhookDescription": "Esta URL (?ignorar=) se registra automáticamente en Efí al guardar. La autenticación es mTLS en el servidor web, no por token.",
    "efiWebhookRequiredHint": "Configure mTLS en el servidor con el certificado público de Efí. Producción: certificados.efipay.com.br/webhooks/certificate-chain-prod.crt — Homologación: certificate-chain-homolog.crt. IP de origen: 34.193.116.226.",
    "efiWebhookMtlsHelp": "Efí valida mTLS en la URL antes de registrar el webhook. Sin mTLS en el dominio, el registro falla.",
    "efiPixOnly": "EFI Bank solo ofrece PIX por ahora.",
    "webhookUrl": "URL del Webhook (Global)",
    "webhookDescription": "Configura esta URL en Mercado Pago → Developers → Webhooks para recibir notificaciones de pago",
    "webhookCopied": "URL del webhook copiada con éxito",
    "accountSalesTitle": "Ventas de Cuentas",
    "accountSalesDesc": "Venda SSH/V2Ray automáticamente",
    "resellerSalesTitle": "Ventas de Revendedores",
    "resellerSalesDesc": "Venda planes de revendedor",
    "publicSalesUrl": "URL Pública de Ventas",
    "publicResellerUrl": "URL Pública de Revendedores",
    "totalSales": "Total de ventas:",
    "totalRevenue": "Ingresos totales:",
    "activeResellers": "Revendedores activos:",
    "categoryNotDefined": "No definida",
    "goToAccountPlansTitle": "¿Ir a Planes de Cuenta?",
    "goToResellerPlansTitle": "¿Ir a Planes de Revendedor?",
    "goToServersTitle": "¿Ir a Servidores?",
    "activeServersInCategory": "{count} servidor(es) activo(s) en esta categoría",
    "noActiveServersInCategory": "Ningún servidor activo en esta categoría — necesario para planes SSH/Combo",
    "featureEnabledWithUrl": "¡Activado! URL: {url}",
    "featureDisabled": "Desactivado"
  },
  "resellers": {
    "title": "Revendedores",
    "subtitle": "Gestiona todos los revendedores",
    "addReseller": "Nuevo Revendedor",
    "editReseller": "Editar Revendedor",
    "username": "Usuario",
    "email": "Correo",
    "category": "Categoría",
    "credit": "Crédito",
    "status": "Estado",
    "actions": "Acciones",
    "noResellers": "No se encontraron revendedores",
    "addCredit": "Agregar Crédito",
    "removeCredit": "Quitar Crédito",
    "search": "Buscar",
    "totalResellers": "Total de Revendedores",
    "activeResellers": "Revendedores Activos",
    "distributedCredits": "Créditos Distribuidos",
    "createdLogins": "Logins Creados",
    "creditsLimit": "Créditos/Límite",
    "type": "Tipo",
    "typeCredit": "Crédito",
    "typeSubscription": "Suscripción",
    "selectCategory": "Seleccione una categoría",
    "initialCredits": "Créditos Iniciales",
    "noResellersFound": "No se encontraron revendedores",
    "clickToCreate": "Haga clic en \"Nuevo Revendedor\" para crear el primero",
    "planType": "Tipo de Plan",
    "planActive": "Plan activo",
    "filters": {
      "search": "Buscar",
      "searchPlaceholder": "Nombre, usuario o correo...",
      "category": "Categoría",
      "allCategories": "Todas las categorías",
      "planType": "Tipo de plan",
      "allTypes": "Todos los tipos",
      "status": "Estado",
      "allStatus": "Todos los estados",
      "creatorType": "Tipo de creador",
      "allCreatorTypes": "Todos los tipos",
      "admins": "Admins",
      "resellersOnly": "Revendedores",
      "creator": "Creador",
      "allCreators": "Todos los creadores",
      "searchCreator": "Buscar creador...",
      "noCreatorsFound": "Ningún creador encontrado"
    },
    "resellers_count": "revendedores",
    "stats": {
      "total": "Total de revendedores",
      "active": "Revendedores activos",
      "creditsDistributed": "Créditos distribuidos",
      "slotsDistributed": "Slots distribuidos",
      "distributedResources": "Recursos distribuidos",
      "loginsCreated": "Logins creados"
    },
    "table": {
      "username": "Usuario",
      "category": "Categoría",
      "creditsLimit": "Créditos/Límite",
      "logins": "Logins",
      "status": "Estado",
      "actions": "Acciones",
      "type": "Tipo",
      "available": "disponibles",
      "total": "total",
      "reseller": "Revendedor",
      "active": "activos"
    },
    "creditsModal": {
      "addCreditsTitle": "Agregar CrÃ©ditos",
      "adjustSubscriptionTitle": "Renovar/Ajustar SuscripciÃ³n",
      "currentBalance": "Saldo Actual",
      "credits": "crÃ©ditos",
      "amount": "Cantidad",
      "amountPlaceholder": "Ej: 100",
      "negativeHelp": "Use valor negativo para quitar crÃ©ditos",
      "observation": "ObservaciÃ³n",
      "observationPlaceholder": "Motivo del cambio...",
      "currentStatus": "Estado Actual",
      "limitHelp": "0 = mantener actual ({current}). En uso: {used} slots"
    },
    "createModal": {
      "manual": "Creación Manual",
      "byPlan": "Por Plan",
      "selectPlan": "Seleccione un Plan",
      "choosePlan": "Elija un plan...",
      "planDetails": "Detalles del Plan",
      "planType": "Tipo",
      "price": "Precio",
      "usernameLabel": "Usuario",
      "usernamePlaceholder": "usuario_revendedor",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "revendedor{'@'}ejemplo.com",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Contraseña de acceso",
      "autoCredentialsInfo": "Indique usuario, correo y contraseña de acceso del revendedor",
      "selectPlanError": "Seleccione un plan y una categoría",
      "categoryRequired": "La categoría es obligatoria",
      "successCreated": "¡Revendedor creado con éxito!",
      "successUpdated": "¡Revendedor actualizado con éxito!",
      "errorSaving": "Error al guardar revendedor"
    },
    "categoryInherited": "Categoría heredada automáticamente de su cuenta de revendedor",
    "newReseller": "Nuevo Revendedor",
    "newResellerShort": "Nuevo",
    "deleteSelectedShort": "Eliminar",
    "selectAll": "Seleccionar Todos",
    "deleteSelected": "Eliminar Seleccionados",
    "passwordRequired": "Contraseña",
    "newPasswordHelp": "Nueva Contraseña (dejar en blanco para mantener)",
    "creditsPlaceholder": "Ej: 100",
    "durationPlaceholder": "Ej: 30",
    "minDurationDaysHelp": "Mínimo: {min} días",
    "loginLimitPlaceholder": "Ej: 50",
    "days": "días",
    "logins": "logins",
    "credits": "créditos",
    "planTypeLabel": "Tipo de Revendedor",
    "creditTypeDesc": "Cantidad de créditos",
    "subscriptionTypeDesc": "Duración + Límite de logins",
    "creditResellerRestriction": "Revendedor tipo CRÉDITO solo puede crear sub-revendedores y planes de CRÉDITO",
    "blockedParentCredit": "🔒 Bloqueado (padre es Crédito)",
    "blockedParentSubscribe": "🔒 Bloqueado (padre es Suscripción)",
    "durationDaysLabel": "Duración (días)",
    "loginLimitLabel": "Límite de Logins",
    "expiresIn": "Expira en:",
    "expiresAt": "Fecha de expiración",
    "editExpiresAtHelp": "Defina manualmente la fecha y hora de vencimiento de la suscripción.",
    "editExpiresAtRequired": "Ingrese la fecha de expiración de la suscripción.",
    "editLimitRequired": "Ingrese el límite de logins (mínimo 1).",
    "editLimitBelowUsage": "El límite no puede ser menor que los logins en uso ({used}).",
    "addDaysLabel": "Agregar DÃ­as",
    "newLimitLabel": "Nuevo LÃ­mite",
    "observationLabel": "ObservaciÃ³n",
    "observationPlaceholder": "Motivo del cambio...",
    "actions": {
      "addCredits": "Agregar Créditos",
      "renewSubscription": "Renovar Suscripción",
      "viewAsReseller": "Ver como este revendedor",
      "activate": "Activar",
      "deactivate": "Desactivar"
    },
    "deleteModal": {
      "title": "Confirmar Eliminación",
      "question": "¿Está seguro de que desea eliminar al revendedor",
      "cannotUndo": "¡Esta acción no se puede deshacer!",
      "creditsReturnTitle": "Los Créditos Serán Devueltos",
      "creditsReturnBody": "Se devolverán {count} crédito(s) al revendedor:",
      "activeLoginsWarning": "¡Este revendedor tiene {count} login(s) activo(s)!",
      "deleting": "Eliminando..."
    },
    "renewSubscription": {
      "title": "Renovar Suscripción",
      "subtitle": "Elija un plan para renovar su suscripción de revendedor.",
      "currentSubscription": "Su Suscripción Actual",
      "slots": "Slots",
      "status": "Estado",
      "expiresAt": "Expira el",
      "loadingPlans": "Cargando planes...",
      "noPlans": "No hay planes de renovación disponibles.",
      "contactAdmin": "Contacte a su administrador.",
      "slotsLabel": "slots",
      "confirmTitle": "Confirmar Renovación",
      "plan": "Plan",
      "duration": "Duración",
      "total": "Total",
      "paymentMethod": "Método de Pago",
      "processing": "Procesando...",
      "payAmount": "Pagar R$ {amount}",
      "openPayment": "Abrir Pago",
      "loadError": "Error al cargar datos. Inténtelo de nuevo.",
      "noGateway": "No hay pasarela de pago configurada.",
      "paymentCreateError": "Error al crear pago",
      "paymentProcessError": "Error al procesar pago"
    },
    "buyCredits": {
      "title": "Comprar Créditos",
      "subtitle": "Adquiera créditos para crear y gestionar cuentas de sus clientes.",
      "currentBalance": "Saldo Actual",
      "creditHint": "1 crédito = 1 cuenta creada por 30 días",
      "loadingPlans": "Cargando planes...",
      "noPlans": "No hay paquetes de créditos disponibles.",
      "contactAdmin": "Contacte a su administrador.",
      "perCredit": "crédito",
      "confirmTitle": "Confirmar Compra",
      "package": "Paquete",
      "creditsLabel": "Créditos",
      "balanceAfter": "Saldo después de la compra",
      "total": "Total",
      "paymentMethod": "Método de Pago",
      "processing": "Procesando...",
      "payAmount": "Pagar R$ {amount}",
      "openPayment": "Abrir Pago",
      "loadError": "Error al cargar datos. Inténtelo de nuevo.",
      "noGateway": "No hay pasarela de pago configurada.",
      "paymentCreateError": "Error al crear pago",
      "paymentProcessError": "Error al procesar pago"
    },
    "bulkDeleteConfirm": {
      "title": "¿Eliminar {count} revendedor(es)?",
      "warning": "¡ATENCIÓN! ¡Esta acción es IRREVERSIBLE!",
      "question": "¿Realmente desea ELIMINAR {count} revendedor(es)?",
      "moreCount": " y {count} más",
      "bulletDb": "Serán eliminados de la base de datos",
      "bulletAccountsKept": "Todas las cuentas creadas por ellos se mantendrán",
      "bulletSalesKept": "Las ventas se mantendrán para el historial",
      "finalWarning": "¡Esta acción NO puede deshacerse!"
    },
    "resultModal": {
      "title": "Revendedor creado con éxito",
      "categoryLabel": "Categoría",
      "planLabel": "Plan",
      "expiresAtLabel": "Válido hasta",
      "accessTitle": "Datos de acceso",
      "createdModePlan": "Por plan",
      "createdModeManual": "Manual",
      "copyHint": "Copie los datos abajo o envíe el mensaje listo por WhatsApp/Telegram."
    },
    "messages": {
      "impersonateSuccess": "Visualizando como: {username}",
      "impersonateError": "Error al entrar en la cuenta del revendedor",
      "impersonateMissingUser": "Revendedor sin usuario asociado"
    }
  },
  "languageSelector": {
    "changed": "Idioma cambiado a {language}!"
  },
  "modals": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "create": "Crear",
    "edit": "Editar",
    "delete": "Eliminar",
    "confirm": "Confirmar",
    "close": "Cerrar",
    "loading": "Cargando...",
    "saving": "Guardando...",
    "deleting": "Eliminando...",
    "success": "¡Éxito!",
    "error": "Error",
    "confirmDelete": "¿Estás seguro de que deseas eliminar?",
    "required": "Campo obligatorio",
    "creating": "Creando...",
    "add": "Agregar"
  },
  "common": {
    "yes": "Sí",
    "no": "No",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "saveNow": "Guardar Ahora",
    "discard": "Descartar",
    "delete": "Eliminar",
    "remove": "Eliminar",
    "edit": "Editar",
    "add": "Añadir",
    "create": "Crear",
    "update": "Actualizar",
    "search": "Buscar",
    "filter": "Filtrar",
    "export": "Exportar",
    "import": "Importar",
    "refresh": "Actualizar",
    "loading": "Cargando...",
    "noData": "No hay datos disponibles",
    "actions": "Acciones",
    "status": "Estado",
    "active": "Activo",
    "inactive": "Inactivo",
    "prevPage": "Anterior",
    "nextPage": "Siguiente",
    "paginationSummary": "Página {page} de {totalPages} · {total} registros",
    "confirmClearNotifications": "¿Limpiar notificaciones?",
    "confirmClearNotificationsDesc": "¿Desea realmente limpiar todas las notificaciones? Esta acción no se puede deshacer.",
    "enabled": "Activado",
    "disabled": "Desactivado",
    "success": "Éxito",
    "error": "Error",
    "warning": "Advertencia",
    "info": "Información",
    "close": "Cerrar",
    "copy": "Copiar",
    "back": "Volver",
    "next": "Siguiente",
    "previous": "Anterior",
    "finish": "Finalizar",
    "total": "Total",
    "from": "Desde",
    "to": "Hasta",
    "date": "Fecha",
    "time": "Hora",
    "name": "Nombre",
    "description": "Descripción",
    "details": "Detalles",
    "settings": "Configuración",
    "profile": "Perfil",
    "logout": "Salir",
    "toggleTheme": "Cambiar tema",
    "login": "Entrar",
    "register": "Registrarse",
    "username": "Usuario",
    "password": "Contraseña",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "address": "Dirección",
    "required": "Requerido",
    "optional": "Opcional",
    "select": "Seleccionar",
    "selectAll": "Seleccionar Todos",
    "deselectAll": "Deseleccionar Todos",
    "perPage": "Por página",
    "showing": "Mostrando",
    "of": "de",
    "results": "resultados",
    "ok": "OK",
    "selectPlaceholder": "Seleccione...",
    "copied": "¡Copiado!",
    "copyError": "Error al copiar",
    "copiedWithLabel": "¡{label} copiado!",
    "copyManual": "Error al copiar. Copie manualmente (Ctrl+C)",
    "noItems": "Ningún elemento encontrado",
    "noItemsDescription": "No hay datos para mostrar",
    "itemsSelected": "{count} elemento(s) seleccionado(s)",
    "itemsPerPage": "Elementos por página:",
    "pageOf": "{current} de {total}",
    "firstPage": "Primera página",
    "prevPageTitle": "Página anterior",
    "nextPageTitle": "Página siguiente",
    "lastPage": "Última página",
    "user": "Usuario",
    "expand": "Expandir menú",
    "collapse": "Contraer menú",
    "menu": "Menú",
    "showPassword": "Mostrar contraseña",
    "hidePassword": "Ocultar contraseña",
    "open": "Abrir",
    "uuid": "UUID",
    "panelLink": "Enlace del panel",
    "notAvailable": "N/D",
    "day": "día",
    "days": "días",
    "unknownError": "Error desconocido",
    "roles": {
      "super_admin": "Super Administrador",
      "admin": "Administrador",
      "reseller": "Revendedor",
      "sub_reseller": "Sub-revendedor",
      "user": "Usuario"
    },
    "closeModal": "Cerrar modal",
    "closeNotification": "Cerrar notificación",
    "closeTab": "Cerrar pestaña {label}",
    "closeError": "Cerrar error"
  },
  "dashboard": {
    "title": "Panel de Control",
    "welcome": "Bienvenido de nuevo, {name}",
    "goodMorning": "¡Buenos días! Aquí está el resumen de tu panel.",
    "goodAfternoon": "¡Buenas tardes! Todo funciona perfectamente.",
    "goodEvening": "¡Buenas noches! Tu panel está operativo.",
    "refresh": "Actualizar",
    "createTest": "Crear Prueba",
    "overview": "Resumen",
    "statistics": "Estadísticas",
    "totalAccounts": "Total de Cuentas",
    "todayCount": "+{count} hoy",
    "activeCount": "✓ {count} activas",
    "expiredCount": "✗ {count} expiradas",
    "servers": "Servidores",
    "serversOnline": "{count} en línea",
    "onlinePercentage": "{percent}% en línea",
    "activeConnections": "Conexiones Activas",
    "onlines": "En línea",
    "onlinesDesc": "Sus cuentas conectadas ahora",
    "onlinesTotal": "Total en línea",
    "onlinesTotalDesc": "Todas las cuentas del panel conectadas",
    "onlinesAdmin": "En línea admin",
    "onlinesAdminDesc": "Cuentas del admin conectadas",
    "rightNow": "Ahora mismo",
    "realtimeMonitoring": "Monitoreo en tiempo real",
    "expiringSoon": "Expirando Pronto",
    "next7Days": "Próximos 7 días",
    "viewAccounts": "Ver cuentas",
    "disabled": "Desactivadas",
    "accountsPaused": "Cuentas pausadas",
    "expired": "Expirados",
    "awaitingRenewal": "Esperando renovación",
    "thisWeek": "Esta Semana",
    "last7Days": "Últimos 7 días",
    "thisMonth": "Este Mes",
    "credits": "Créditos",
    "buyCreditsHint": "Clic para comprar más",
    "slots": "Slots",
    "subscription": {
      "expiredBanner": "¡Su suscripción expiró! Sus funciones están bloqueadas.",
      "expiringBanner": "Su suscripción expira en {days} día(s). Renueve para seguir operando.",
      "renewNow": "Renovar Ahora",
      "expiresTooltip": "Expira: {date}",
      "expired": "Expirada",
      "oneDay": "1 día",
      "daysShort": "{days}d",
      "daysCount": "{days} días",
      "daysRemaining": "Días restantes",
      "accessExpiresAt": "Acceso válido hasta {date}",
      "managementPanel": "Panel de Gestión"
    },
    "topResellers": "Top Revendedores",
    "topResellersDesc": "Revendedores con más cuentas creadas",
    "position": "Posición",
    "reseller": "Revendedor",
    "activeAccounts": "Activas",
    "activationRate": "Tasa de Activación",
    "totalAccountsDesc": "Total en el sistema",
    "totalAdmin": "Cuentas Admin",
    "totalAdminDesc": "Creadas por admin",
    "expiredAdmin": "Expirados Admin",
    "expiredAdminDesc": "Expiradas por admin",
    "salesToday": "Ventas Hoy",
    "salesMonth": "Ventas del Mes",
    "salesTotal": "Ingresos Totales",
    "salesCount": "{count} venta(s)",
    "salesTrend": "Tendencia de Ventas",
    "accountGrowth": "Crecimiento de Cuentas",
    "totalUsers": "Total de Usuarios",
    "activeUsers": "Usuarios Activos",
    "totalServers": "Total de Servidores",
    "activeServers": "Servidores Activos",
    "totalSSH": "Cuentas SSH",
    "totalV2Ray": "Cuentas V2Ray",
    "onlineUsers": "Usuarios en Línea",
    "offlineUsers": "Usuarios Fuera de Línea",
    "revenue": "Ingresos",
    "lastMonth": "Mes Pasado",
    "growth": "Crecimiento",
    "recentUsers": "Usuarios Recientes",
    "recentActivities": "Actividades Recientes",
    "systemHealth": "Salud del Sistema",
    "cpuUsage": "Uso de CPU",
    "memoryUsage": "Uso de Memoria",
    "diskUsage": "Uso de Disco",
    "networkTraffic": "Tráfico de Red"
  },
  "users": {
    "title": "Gestionar Usuarios",
    "createUser": "Crear Usuario",
    "editUser": "Editar Usuario",
    "deleteUser": "Eliminar Usuario",
    "username": "Usuario",
    "password": "Contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "email": "Correo",
    "phone": "Teléfono",
    "expirationDate": "Fecha de Expiración",
    "connectionLimit": "Límite de Conexiones",
    "deviceLimit": "Límite de Dispositivos",
    "server": "Servidor",
    "category": "Categoría",
    "notes": "Notas",
    "totalUsers": "Total de Usuarios",
    "activeUsers": "Usuarios Activos",
    "expiredUsers": "Usuarios Expirados",
    "suspendedUsers": "Usuarios Suspendidos",
    "userCreated": "¡Usuario creado con éxito!",
    "userUpdated": "¡Usuario actualizado con éxito!",
    "userDeleted": "¡Usuario eliminado con éxito!",
    "confirmDelete": "¿Está seguro de que desea eliminar este usuario?",
    "suspendUser": "Suspender Usuario",
    "activateUser": "Activar Usuario",
    "renewUser": "Renovar Usuario"
  },
  "payment": {
    "title": "Pagos",
    "config": "Configuración de Pagos",
    "create": "Crear Pago",
    "history": "Historial de Pagos",
    "paymentLink": "Enlace de Pago",
    "qrCode": "Código QR",
    "amount": "Monto",
    "discount": "Descuento",
    "total": "Total",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "cancelled": "Cancelado",
    "paymentCreated": "¡Pago creado con éxito!",
    "copyLink": "Copiar Enlace",
    "shareWhatsApp": "Compartir en WhatsApp",
    "sendEmail": "Enviar por Correo",
    "print": "Imprimir",
    "expiresAt": "Expira en",
    "clientName": "Nombre del Cliente",
    "clientEmail": "Correo del Cliente",
    "clientPhone": "Teléfono del Cliente",
    "selectGateway": "Seleccionar Pasarela de Pago",
    "configureGateway": "Configurar Pasarela de Pago",
    "gatewayNotConfigured": "Pasarela de pago no configurada"
  },
  "coupons": {
    "title": "Cupones de Descuento",
    "subtitle": "Cree y gestione cupones de descuento para sus clientes",
    "newCoupon": "Nuevo Cupón",
    "newCouponShort": "Nuevo",
    "createCoupon": "Crear Cupón",
    "editCoupon": "Editar Cupón",
    "deleteCoupon": "Eliminar Cupón",
    "code": "Código",
    "discountType": "Tipo de Descuento",
    "percentage": "Porcentaje",
    "fixedValue": "Valor Fijo",
    "discountAmount": "Monto de Descuento",
    "percentLabel": "Porcentaje (%)",
    "fixedLabel": "Valor (R$)",
    "maxUses": "Usos Máximos",
    "validUntil": "Válido Hasta",
    "activate": "Activar",
    "deactivate": "Desactivar",
    "active": "Activo",
    "inactive": "Inactivo",
    "total": "Total",
    "activeCount": "Activos",
    "uses": "Usos",
    "emptyTitle": "Ningún cupón",
    "emptyHint": "Cree su primer cupón de descuento",
    "discountLabel": "Descuento:",
    "usesLabel": "Usos:",
    "validUntilLabel": "Válido hasta:",
    "codePlaceholder": "DESC10",
    "percentPlaceholder": "10.00",
    "fixedPlaceholder": "5.00",
    "percentageExample": "Ej: 10%",
    "fixedExample": "Ej: $5",
    "unlimitedPlaceholder": "Ilimitado",
    "deleteConfirm": "¿Está seguro de que desea eliminar el cupón \"{code}\"?",
    "couponApplied": "¡Cupón aplicado!",
    "couponInvalid": "Cupón inválido o expirado",
    "couponCreated": "¡Cupón creado con éxito!",
    "couponUpdated": "¡Cupón actualizado con éxito!",
    "couponDeleted": "¡Cupón eliminado con éxito!"
  },
  "notifications": {
    "title": "Notificaciones",
    "empty": "Ninguna notificación",
    "unreadTitle": "{count} notificación(es) no leída(s)",
    "markAllRead": "Marcar como leídas",
    "clearAll": "Limpiar todas",
    "remove": "Eliminar notificación"
  },
  "backupJobProgress": {
    "processing": "Procesando...",
    "doNotClose": "Esto puede tardar unos minutos. No cierre esta ventana.",
    "completed": "¡Completado con éxito!",
    "fileInfo": "Archivo: {filename} ({size} MB)",
    "errorPrefix": "Error:",
    "failed": "Fallo en el procesamiento",
    "pending": "Esperando procesamiento..."
  },
  "install": {
    "title": "Instalación del Sistema",
    "welcome": "Bienvenido a {panelName}",
    "subtitle": "Configura tu sistema en pocos minutos",
    "selectLanguage": "Selecciona tu Idioma",
    "step1": "Base de Datos",
    "step2": "Administrador",
    "step3": "Finalización",
    "dbHost": "Host de la Base de Datos",
    "dbUser": "Usuario de la Base de Datos",
    "dbPassword": "Contraseña de la Base de Datos",
    "dbName": "Nombre de la Base de Datos",
    "testConnection": "Probar Conexión",
    "testingConnection": "Probando...",
    "connectionSuccess": "Conexión establecida con éxito",
    "connectionError": "Error al conectar a la base de datos",
    "installing": "Instalando Sistema...",
    "installComplete": "¡Instalación Completa!",
    "installSuccess": "Sistema configurado con éxito",
    "accessSystem": "Acceder al Sistema",
    "creatingTables": "Creando tablas...",
    "insertingData": "Insertando datos predeterminados...",
    "configuringSystem": "Configurando sistema...",
    "finalizingInstall": "Finalizando instalación..."
  },
  "validation": {
    "required": "Este campo es obligatorio",
    "email": "Ingresa un correo válido",
    "minLength": "Debe tener al menos {min} caracteres",
    "maxLength": "Debe tener como máximo {max} caracteres",
    "min": "Debe ser mayor o igual a {min}",
    "max": "Debe ser menor o igual a {max}",
    "alphanumeric": "Debe contener solo letras y números",
    "numeric": "Debe contener solo números",
    "url": "Ingresa una URL válida",
    "ip": "Ingresa una IP válida",
    "port": "Ingresa un puerto válido (1-65535)",
    "passwordStrength": "La contraseña debe contener mayúsculas, minúsculas, números y caracteres especiales",
    "passwordMatch": "Las contraseñas no coinciden",
    "unique": "Este valor ya está en uso",
    "dateFormat": "Formato de fecha inválido",
    "futureDate": "La fecha debe ser futura",
    "pastDate": "La fecha debe ser pasada"
  },
  "salesMetrics": {
    "title": "Métricas de Ventas",
    "subtitle": "Seguimiento del rendimiento financiero e historial de pagos",
    "totalRevenue": "Ingresos Totales",
    "monthRevenue": "Ingresos del Mes",
    "todayRevenue": "Ingresos Hoy",
    "pendingPayments": "Pagos Pendientes",
    "awaitingConfirmation": "Esperando confirmación",
    "sales": "venta(s)",
    "revenue": "Ingresos",
    "revenueLast30Days": "Ingresos — Últimos 30 Días",
    "revenueByMonth": "Ingresos por Mes",
    "byProductType": "Por Tipo de Producto",
    "byGateway": "Por Pasarela",
    "paymentsHistory": "Historial de Pagos",
    "allStatuses": "Todos los estados",
    "allTypes": "Todos los tipos",
    "statusApproved": "Aprobado",
    "statusPending": "Pendiente",
    "statusCancelled": "Cancelado",
    "statusExpired": "Expirado",
    "typeAccount": "Cuenta VPN",
    "typeReseller": "Revendedor",
    "typeResellerRenewal": "Renovación de revenda",
    "typeResellerCredits": "Compra de créditos",
    "typeOther": "Otros",
    "emptyValue": "—",
    "monthYearLabel": "{month}/{year}",
    "monthsShort": ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    "gateways": {
      "mercadopago": "Mercado Pago",
      "asaas": "Asaas",
      "paypal": "PayPal",
      "manual": "Manual",
      "pagseguro": "PagSeguro"
    },
    "dateFrom": "Fecha inicio",
    "dateTo": "Fecha fin",
    "colDate": "Fecha",
    "colDescription": "Descripción",
    "colType": "Tipo",
    "colGateway": "Pasarela",
    "colStatus": "Estado",
    "colValue": "Valor",
    "noData": "Sin datos en el período",
    "noPayments": "No se encontraron pagos",
    "page": "Página",
    "records": "registro(s)",
    "prev": "Anterior",
    "next": "Siguiente"
  },
  "notFound": {
    "documentTitle": "404 — {panel}",
    "page_title": "Página no encontrada",
    "subtitle": "La dirección puede ser incorrecta o la página fue eliminada",
    "title": "No encontramos esta ruta",
    "message": "Verifique el enlace o use los accesos directos para volver al panel.",
    "attempted_path": "Ruta solicitada",
    "suggestions": "Accesos útiles",
    "goBack": "Volver",
    "goHome": "Ir al panel",
    "help_hint": "Si el problema continúa, contacte al administrador del panel",
    "needHelp": "¿Necesitas ayuda?",
    "contactSupport": "Contáctanos",
    "dashboardDesc": "Resumen del sistema",
    "accountsDesc": "Gestionar cuentas",
    "serversDesc": "Gestionar servidores",
    "settingsDesc": "Configuración del panel"
  },
  "publicStoreAlerts": {
    "ok": "OK",
    "notice": "Aviso",
    "warning": "Atención",
    "info": "Información"
  },
  "publicStore": {
    "types": {
      "ssh": "SSH",
      "v2ray": "V2Ray",
      "combo": "SSH + V2Ray"
    },
    "account": {
      "subtitle": "Elige tu plan de acceso SSH/V2Ray",
      "loadingPlans": "Cargando planes...",
      "validityDays": "{days} días de validez",
      "unlimitedConnections": "Conexiones ilimitadas",
      "connectionsCount": "{count} conexiones",
      "instantActivation": "Activación inmediata",
      "support247": "Soporte 24/7",
      "buyNow": "Comprar Ahora",
      "noPlans": "No hay planes disponibles en este momento.",
      "noServersInCategoryTitle": "Tienda temporalmente no disponible",
      "noServersInCategory": "No hay servidores activos en la categoría definida para ventas. Contacte al vendedor.",
      "filterPlans": "Filtrar planes por tipo"
    },
    "reseller": {
      "subtitle": "Conviértete en revendedor — elige tu plan",
      "loadingPlans": "Cargando planes...",
      "typeCredit": "Crédito",
      "typeSubscribe": "Suscripción",
      "filterPlans": "Filtrar planes por tipo",
      "creditsAmount": "{count} créditos",
      "durationDays": "{days} días",
      "simultaneousLogins": "{count} inicios simultáneos",
      "managementPanel": "Panel de gestión",
      "instantActivation": "Activación inmediata",
      "fullSupport": "Soporte completo",
      "becomeReseller": "Convertirse en Revendedor",
      "noPlans": "No hay planes de reventa disponibles en este momento."
    }
  },
  "publicPayment": {
    "checkout": "Finalizar Compra",
    "selectedPlan": "Plan seleccionado",
    "planSummary": "{days} días • {connections} conexiones",
    "fullName": "Nombre Completo",
    "email": "Email",
    "cpf": "CPF",
    "whatsappOptional": "WhatsApp (opcional)",
    "telegramOptional": "Telegram (opcional)",
    "placeholderName": "Tu nombre",
    "payerNameHint": "Nombre completo del titular del CPF (obligatorio para PIX en Mercado Pago)",
    "placeholderEmail": "tu{'@'}email.com",
    "placeholderCpf": "000.000.000-00",
    "placeholderWhatsapp": "(11) 99999-9999",
    "placeholderTelegram": "{'@'}usuario o ID",
    "cancel": "Cancelar",
    "continue": "Continuar",
    "back": "Volver",
    "paymentMethodTitle": "Forma de Pago",
    "processing": "Procesando...",
    "payNow": "Pagar Ahora",
    "noPaymentMethods": "No hay métodos de pago disponibles",
    "paymentCreateError": "Error al crear el pago. Intenta de nuevo.",
    "cpfInvalid": "Ingresa un CPF válido (11 dígitos con dígitos verificadores correctos).",
    "dataAlreadyExists": "Los datos ya existen",
    "resellerCredentialsTitle": "Credenciales de Acceso al Panel",
    "resellerCredentialsHelp": "Elige tus credenciales para acceder al panel de revendedor",
    "username": "Usuario",
    "usernameTaken": "El nombre de usuario ya está en uso. Elige otro.",
    "usernameAvailable": "¡Usuario disponible!",
    "usernameRequired": "Ingresa un nombre de usuario.",
    "checkingUsername": "Verificando usuario...",
    "usernameCheckError": "No se pudo verificar el usuario. Inténtalo de nuevo.",
    "emailTaken": "El correo ya está en uso. Elige otro.",
    "emailAvailable": "¡Correo disponible!",
    "checkingEmail": "Verificando correo...",
    "emailCheckError": "No se pudo verificar el correo. Inténtalo de nuevo.",
    "checkingCredentials": "Verificando datos...",
    "payerNameRequired": "Ingresa el nombre completo del pagador.",
    "nameRequired": "Ingresa tu nombre completo.",
    "emailRequired": "Ingresa un correo electrónico.",
    "emailInvalid": "Ingresa un correo electrónico válido.",
    "cpfRequired": "Ingresa el CPF.",
    "passwordRequired": "La contraseña debe tener al menos 6 caracteres.",
    "usernamePlaceholder": "tunombre123",
    "emailForLogin": "Email",
    "emailForLoginHint": "(para iniciar sesión en el panel)",
    "emailPlaceholder": "email{'@'}panel.com",
    "password": "Contraseña",
    "passwordHint": "(mínimo 6 caracteres)",
    "methodInstant": "Instantáneo",
    "methodCash": "Efectivo",
    "methodCard": "Tarjeta",
    "methodBankTransfer": "Transferencia",
    "methodWallet": "Billetera",
    "pixTitle": "Pago PIX",
    "pixStepScan": "Escanea el QR",
    "pixStepPay": "Confirma en la app",
    "pixStepWait": "Espera aquí",
    "pixExpiresIn": "Expira en ~{minutes} min",
    "pixExpired": "PIX expirado",
    "pixScanHint": "Escanea con la app de tu banco",
    "pixCopyLabel": "O copia la clave PIX:",
    "copy": "Copiar",
    "copied": "¡Copiado!",
    "pixInstructions": "Abre la app de tu banco → PIX → Escanear QR o Pegar Clave",
    "awaitingConfirmation": "Esperando confirmación...",
    "cancelPayment": "Cancelar Pago",
    "cancelling": "Cancelando...",
    "close": "Cerrar",
    "pixExpiresHint": "El PIX expira automáticamente si no se paga",
    "paymentConfirmed": "¡Pago Confirmado!",
    "accountCreated": "Tu cuenta fue creada con éxito",
    "resellerActivated": "¡Tu panel de revendedor fue activado!",
    "creditsAddedSuccess": "¡Créditos agregados con éxito!",
    "creditsAddedLabel": "Créditos agregados",
    "newCreditsBalance": "Nuevo saldo",
    "creditsPurchaseToast": "+{added} créditos agregados! Saldo actual: {balance}",
    "validUntil": "Válido hasta: {date}",
    "userLabel": "Usuario",
    "passwordLabel": "Contraseña",
    "uuidLabel": "UUID (V2Ray)",
    "copyAllCredentials": "Copiar Todas las Credenciales",
    "copyResellerCredentials": "Copiar Credenciales de Acceso",
    "typeLabel": "Tipo",
    "limitLabel": "Límite",
    "creditsLabel": "Créditos",
    "resellerPanelCredentials": "Credenciales del Panel de Revendedor",
    "panelUrl": "URL del Panel",
    "saveCredentialsWarning": "¡Guarda esta información en un lugar seguro!",
    "cancelPaymentConfirm": "¿Seguro que deseas cancelar este pago?\n\nEl PIX ya no podrá pagarse después de la cancelación.",
    "cancelPaymentError": "Error al cancelar el pago. Intenta de nuevo.",
    "copyManualPrompt": "Haz clic en OK para ver tus credenciales y copiar manualmente:",
    "copyManualTitle": "Copia estas credenciales (Ctrl+C):",
    "successTitle": "¡Pago Aprobado!",
    "successSubtitle": "Tus credenciales están listas",
    "credentialsSentEmail": "Las credenciales también fueron enviadas a tu email.",
    "resellerWelcome": "¡Bienvenido!",
    "resellerSuccessSubtitle": "Tu reventa fue activada con éxito",
    "resellerLoginHint": "¡Inicia sesión en el panel para comenzar!",
    "resellerEmailSent": "Los datos de acceso fueron enviados a tu email.",
    "successModal": {
      "expiresAtLabel": "Válido hasta",
      "connectionLimitLabel": "Límite de conexiones",
      "loginLimitValue": "{limit} inicios de sesión"
    }
  },
  "renewal": {
    "title": "Renovar Acceso",
    "subtitle": "Renueva tu cuenta SSH/V2Ray de forma rápida y segura",
    "step1Title": "Encuentra tu cuenta",
    "usernameOrUuidLabel": "Usuario o UUID V2Ray",
    "usernameOrUuidPlaceholder": "Ingresa tu usuario o UUID",
    "usernameOrUuidHelp": "Ingresa el nombre de usuario SSH o UUID V2Ray",
    "searchButton": "Buscar Cuenta",
    "searching": "Buscando...",
    "accountNotFound": "Cuenta no encontrada",
    "searchError": "Error al buscar cuenta. Intenta de nuevo.",
    "accountFound": "¡Cuenta Encontrada!",
    "accountFoundSubtitle": "Elige un plan para renovar",
    "username": "Usuario",
    "type": "Tipo",
    "expiresAt": "Vence en",
    "status": "Estado",
    "expired": "Expirada",
    "active": "Activa",
    "availablePlans": "Planes Disponibles",
    "loadingPlans": "Cargando planes...",
    "days": "días",
    "connections": "conexiones",
    "renewNow": "Renovar Ahora",
    "noPlansAvailable": "No hay planes disponibles para renovación",
    "payment": "Pago",
    "changePlan": "Cambiar plan",
    "selectedPlan": "Plan seleccionado",
    "customerName": "Nombre Completo",
    "optional": "opcional",
    "paymentMethod": "Método de pago",
    "noPaymentMethods": "No hay métodos de pago disponibles.",
    "processing": "Procesando...",
    "payNow": "Pagar ahora",
    "paymentCreateError": "Error al crear el pago",
    "paymentProcessError": "Error al procesar el pago",
    "typeSsh": "SSH",
    "typeV2ray": "V2Ray",
    "typeCombo": "SSH + V2Ray"
  },
  "nav": {
    "dashboard": "Panel",
    "accounts": "Cuentas",
    "servers": "Servidores",
    "categories": "Categorías",
    "resellers": "Revendedores",
    "payments": "Pagos",
    "gateways": "Pasarelas",
    "salesMetrics": "Métricas",
    "coupons": "Cupones",
    "settings": "Configuración",
    "profile": "Perfil",
    "logout": "Salir",
    "panel": "Panel",
    "manage": "Gestionar",
    "plans": "Planes",
    "system": "Sistema",
    "administrators": "Administradores",
    "branding": "Branding",
    "checkuser": "CheckUser",
    "manageBackup": "Gestionar Backup",
    "systemLogs": "Logs del Sistema",
    "users": "Usuarios",
    "automaticResale": "Reventa Automática",
    "portal": "Portal",
    "createLogin": "Crear Login",
    "devices": "Dispositivos",
    "paymentHistory": "Historial de Pagos",
    "configuration": "Configuración",
    "myUsers": "Mis Usuarios"
  },
  "errors": {
    "generic": "Ocurrió un error inesperado",
    "networkError": "Error de conexión con el servidor",
    "serverError": "Error interno del servidor",
    "notFound": "Recurso no encontrado",
    "unauthorized": "No tienes permiso para acceder a este recurso",
    "forbidden": "Acceso denegado",
    "badRequest": "Solicitud inválida",
    "timeout": "La solicitud tardó demasiado",
    "tooManyRequests": "Demasiadas solicitudes. Espera un momento.",
    "maintenance": "Sistema en mantenimiento. Intenta más tarde.",
    "tryAgain": "Intenta nuevamente",
    "contactSupport": "Si el problema persiste, contacta al soporte"
  },
  "success": {
    "operationSuccess": "Operación completada con éxito",
    "created": "Creado con éxito",
    "updated": "Actualizado con éxito",
    "deleted": "Eliminado con éxito",
    "saved": "Guardado con éxito",
    "copied": "Copiado al portapapeles",
    "sent": "Enviado con éxito",
    "uploaded": "Carga completada con éxito",
    "downloaded": "Descarga completada con éxito",
    "imported": "Importado con éxito",
    "exported": "Exportado con éxito"
  },
  "license": {
    "invalid": {
      "page_title": "Licencia no disponible",
      "title": "Licencia inválida o expirada",
      "subtitle": "Este panel necesita una licencia válida para seguir operando",
      "error_occurred": "Error de validación de licencia",
      "default_error_title": "Acceso denegado",
      "default_error_message": "Su licencia es inválida, expiró o este dominio no está autorizado para usar {panelName}.",
      "domain_info": "Información del dominio",
      "current_domain": "Dominio actual",
      "status": "Estado de la licencia",
      "status_invalid": "Inválida",
      "reason_code": "Código del motivo",
      "what_to_do": "¿Qué hacer?",
      "step_1": "Contacte al proveedor del sistema o soporte técnico",
      "step_2": "Informe el dominio actual para activar o renovar la licencia",
      "step_3": "Después de la corrección, use «Verificar licencia» o recargue el panel",
      "contact_support": "Contactar soporte",
      "recheck": "Verificar licencia de nuevo",
      "checking": "Verificando...",
      "recheck_success": "¡Licencia validada! Redirigiendo al panel...",
      "recheck_still_invalid": "La licencia sigue inválida. Confirme con soporte e intente de nuevo.",
      "recheck_failed": "No se pudo verificar ahora. Intente nuevamente en unos instantes.",
      "managed_externally": "Licencias gestionadas externamente"
    },
    "status": {
      "expired": {
        "title": "Licencia expirada",
        "message": "La licencia de este dominio expiró. Renuévela para volver a usar {panelName}.",
        "badge": "Expirada",
        "hint": "Solicite la renovación indicando el dominio actual."
      },
      "suspended": {
        "title": "Licencia suspendida",
        "message": "Esta licencia fue suspendida por el administrador de la plataforma.",
        "badge": "Suspendida",
        "hint": "Contacte soporte para regularizar la situación."
      },
      "draft": {
        "title": "Licencia no activada",
        "message": "La licencia aún está en borrador y no fue liberada para uso.",
        "badge": "Borrador",
        "hint": "Espere la activación oficial de la licencia en este dominio."
      },
      "not_found": {
        "title": "Licencia no encontrada",
        "message": "No encontramos una licencia válida asociada a esta instalación.",
        "badge": "No encontrada",
        "hint": "Confirme que LICENSE_KEY es correcta en el servidor."
      },
      "domain_mismatch": {
        "title": "Dominio no autorizado",
        "message": "Esta licencia está vinculada a otro dominio y no puede usarse aquí.",
        "badge": "Dominio incorrecto",
        "hint": "Solicite la migración de la licencia al dominio actual."
      },
      "missing_license_key": {
        "title": "Clave de licencia ausente",
        "message": "El servidor no tiene LICENSE_KEY configurada para validar el panel.",
        "badge": "Sin clave",
        "hint": "Configure LICENSE_KEY en el archivo .env del backend."
      },
      "grace_period_expired": {
        "title": "Validación offline expirada",
        "message": "El período de uso offline terminó. Reconecte el servidor a internet para revalidar.",
        "badge": "Offline expirado",
        "hint": "Verifique conectividad con el servidor de licencias."
      },
      "connection_error": {
        "title": "Fallo de conexión",
        "message": "No fue posible contactar al servidor de licencias en este momento.",
        "badge": "Sin conexión",
        "hint": "Revise internet, firewall y LICENSE_SERVER_URL."
      },
      "validation_failed": {
        "title": "Validación fallida",
        "message": "La validación de la licencia falló y el panel fue bloqueado por seguridad.",
        "badge": "Validación fallida",
        "hint": "Revise LICENSE_KEY, dominio y logs del servidor."
      },
      "critical_error": {
        "title": "Error crítico de licencia",
        "message": "Ocurrió un error interno al validar la licencia.",
        "badge": "Error crítico",
        "hint": "Consulte los logs del backend y contacte soporte."
      },
      "unknown": {
        "title": "Licencia no liberada",
        "message": "No se pudo confirmar la licencia para este dominio.",
        "badge": "Indefinido",
        "hint": "Informe el código del motivo al soporte."
      },
      "invalid": {
        "title": "Licencia inválida",
        "message": "La licencia de este dominio no es válida para usar {panelName}.",
        "badge": "Inválida",
        "hint": "Solicite activación o renovación indicando el dominio actual."
      }
    }
  },
  "adminManagement": {
    "title": "Gestión de Administradores",
    "subtitle": "Gestione administradores y moderadores del sistema (solo Super Admin)",
    "newAdmin": "Nuevo Administrador",
    "reload": "Recargar",
    "saveChanges": "Guardar Cambios",
    "filters": {
      "search": "Buscar",
      "searchPlaceholder": "Nombre, usuario o correo...",
      "role": "Rol",
      "allRoles": "Todos",
      "status": "Estado",
      "allStatus": "Todos"
    },
    "stats": {
      "superAdmins": "Super Admins",
      "admins": "Admins",
      "moderators": "Moderadores",
      "active": "Activos"
    },
    "empty": {
      "title": "No se encontraron administradores",
      "description": "Haga clic en \"Nuevo Administrador\" para crear el primero"
    },
    "table": {
      "administrator": "Administrador",
      "role": "Rol",
      "status": "Estado",
      "lastLogin": "Último Acceso",
      "createdAt": "Creado en",
      "actions": "Acciones",
      "never": "Nunca"
    },
    "roles": {
      "super_admin": "Super Admin",
      "admin": "Admin",
      "moderator": "Moderador"
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "actions": {
      "activate": "Activar",
      "deactivate": "Desactivar",
      "edit": "Editar",
      "delete": "Eliminar"
    },
    "modal": {
      "createTitle": "Nuevo Administrador",
      "editTitle": "Editar Administrador",
      "close": "Cerrar",
      "cancel": "Cancelar",
      "save": "Guardar Cambios",
      "create": "Crear Administrador",
      "saving": "Guardando...",
      "deleting": "Eliminando..."
    },
    "form": {
      "username": "Usuario",
      "usernamePlaceholder": "Ej: juan_admin",
      "usernameHelp": "3-50 caracteres alfanuméricos (no se puede cambiar después)",
      "email": "Correo",
      "emailPlaceholder": "email{'@'}ejemplo.com",
      "role": "Rol",
      "adminRole": "Admin - Acceso completo",
      "moderatorRole": "Moderador - Acceso limitado",
      "roleHelp": "Super Admin no se puede crear via interfaz",
      "password": "Contraseña",
      "newPassword": "Nueva Contraseña (opcional)",
      "passwordPlaceholder": "Mínimo 6 caracteres",
      "passwordHelp": "Dejar en blanco para mantener la contraseña actual",
      "activeStatus": "Estado Activo",
      "activeStatusHelp": "Administrador puede iniciar sesión"
    },
    "delete": {
      "title": "Confirmar Eliminación",
      "message": "¿Está seguro de que desea eliminar el administrador",
      "warning": "Esta acción no se puede deshacer.",
      "confirm": "Eliminar"
    },
    "messages": {
      "createSuccess": "¡Administrador creado con éxito!",
      "updateSuccess": "¡Administrador actualizado con éxito!",
      "deleteSuccess": "¡Administrador eliminado con éxito!",
      "statusChanged": "¡Estado cambiado con éxito!",
      "createError": "Error al crear administrador",
      "updateError": "Error al actualizar administrador",
      "deleteError": "Error al eliminar administrador",
      "loadError": "Error al cargar administradores",
      "superAdminOnly": "Solo el Super Admin puede acceder a esta área."
    },
    "viewOnly": "Solo lectura",
    "branding": {
      "title": "Branding y Personalización",
      "description": "Gestiona logos, íconos, favicon y apariencia visual del panel",
      "tabs": {
        "logos": "Logos",
        "icons": "Íconos y Favicon",
        "pwa": "PWA y Redes Sociales"
      },
      "upload": "Subir Archivo",
      "replace": "Reemplazar",
      "remove": "Eliminar",
      "previewDefault": "Ver Predeterminado",
      "customBadge": "Custom",
      "defaultBadge": "Predeterminado",
      "uploading": "Subiendo...",
      "formats": "Formatos",
      "maxSize": "Máx",
      "maxSourceSize": "Foto hasta {max} MB (recorte y compresión automáticos)",
      "filePath": "Archivo",
      "showDefault": "Ver Predeterminado",
      "showCustom": "Ver Custom",
      "fileTooLarge": "¡Archivo demasiado grande!\n\nTamaño: {size} MB\nMáximo: {max} MB\n\nPor favor, comprime la imagen antes de subirla.",
      "logosAndIconsDesc": "Personaliza la identidad visual de tu panel",
      "recommendedSize": "Tamaño recomendado: 512x512px",
      "pwaSettings": "Configuraciones PWA",
      "pwaName": "Nombre Completo de la Aplicación",
      "pwaShortName": "Nombre Corto (máx 12 caracteres)",
      "pwaDescription": "Descripción de la Aplicación",
      "themeColor": "Color del Tema",
      "dashboardLogo": "Logo del Dashboard",
      "loginLogo": "Logo de Pantalla de Inicio",
      "panelLogo": "Logo General del Panel",
      "faviconSvg": "Favicon SVG",
      "faviconPng": "Favicon PNG",
      "appleTouchIcon": "Apple Touch Icon",
      "appIcon192": "Ícono PWA 192x192",
      "appIcon512": "Ícono PWA 512x512",
      "ogImage": "Imagen Open Graph",
      "dashboardLogoDesc": "Mostrado en la barra lateral y encabezado del panel admin",
      "loginLogoDesc": "Mostrado en la pantalla de inicio de sesión",
      "panelLogoDesc": "Logo principal usado en emails, documentos, etc",
      "faviconSvgDesc": "Ícono de la pestaña del navegador - formato vectorial (recomendado)",
      "faviconPngDesc": "Alternativa para navegadores que no soportan SVG",
      "appleTouchIconDesc": "Ícono al agregar a la pantalla de inicio de iOS",
      "appIcon192Desc": "Ícono PWA para Android/Chrome",
      "appIcon512Desc": "Ícono HD para splash screen e instalación",
      "ogImageDesc": "Imagen para compartir en redes sociales (Facebook, Twitter, WhatsApp)"
  },
  "settingsPage": {
      "title": "Configuraciones del Panel",
      "description": "Personaliza apariencia, seguridad y comportamiento del sistema",
      "tabs": {
        "branding": "Branding",
        "security": "Seguridad",
        "backup": "Backup",
        "cleanup": "Limpieza",
        "advanced": "Avanzado",
        "templates": "Mensajes"
      },
      "branding": {
        "panelInfo": "Información del Panel",
        "panelName": "Nombre del Panel",
        "panelNamePlaceholder": "Ej: Mi Panel",
        "pwaShortName": "Nombre Corto PWA",
        "pwaShortNamePlaceholder": "Ej: MiPanel",
        "max12chars": "Máximo 12 caracteres",
        "description": "Descripción",
        "descriptionPlaceholder": "Describa su panel...",
        "logosAndIcons": "Logos e Íconos",
        "dashboardLogo": "Logo del Dashboard",
        "dashboardLogoDesc": "Mostrado en sidebar y header",
        "loginLogo": "Logo de Inicio de Sesión",
        "loginLogoDesc": "Mostrado en pantalla de inicio",
        "favicon": "Favicon",
        "faviconDesc": "Ícono de pestaña del navegador",
        "pwaIcon": "Ícono PWA 192",
        "pwaIconDesc": "Instalación móvil (192x192)",
        "pwaIcon512": "Ícono PWA 512",
        "pwaIcon512Desc": "Pantalla de inicio móvil (512x512)",
        "appleIcon": "Apple Touch Icon",
        "appleIconDesc": "Pantalla de inicio iOS (180x180)",
        "ogImage": "Open Graph",
        "ogImageDesc": "Compartir en redes sociales",
        "colors": "Colores del Tema",
        "primaryColor": "Color Primario",
        "secondaryColor": "Color Secundario"
      },
      "security": {
        "title": "Seguridad",
        "maxLoginAttempts": "Intentos Máximos de Inicio de Sesión",
        "attemptsRange": "Entre 3 y 10 intentos",
        "sessionTimeout": "Tiempo de Sesión (minutos)",
        "timeoutRange": "Entre 30 y 1440 minutos (24h)",
        "resellerMaxTestHours": "Límite de Prueba (Revendedores)",
        "hours": "horas",
        "resellerMaxTestHoursHelp": "Tiempo máximo en horas (1-72). Admin sin límite.",
        "resellerLimitInfo": "ℹ️ Control de Cuentas de Prueba",
        "resellerLimitInfo1": "Revendedores pueden crear pruebas de hasta {hours} horas",
        "resellerLimitInfo2": "Admin y Super Admin sin límite (hasta 72h)",
        "resellerLimitInfo3": "Configuración aplicada inmediatamente después de guardar"
      },
      "backup": {
        "title": "Backup Automático",
        "enableBackup": "Habilitar Backup Automático",
        "enableBackupDesc": "El backup de la base de datos se enviará por Telegram",
        "interval": "Intervalo (minutos)",
        "intervalDesc": "Cada cuántos minutos hacer backup (ej: 1440 = 24h)",
        "telegramBot": "Token del Bot Telegram",
        "telegramBotPlaceholder": "123456:ABC-DEF...",
        "telegramChat": "Chat ID de Telegram",
        "telegramChatPlaceholder": "-100123456789",
        "restoreBackup": "Restaurar Backup",
        "selectFile": "Seleccione el archivo de backup",
        "acceptedFormats": "Formatos aceptados: .enc, .sql",
        "invalidFile": "Archivo inválido. Use solo .enc o .sql",
        "decryptPassword": "Contraseña de desencriptación",
        "decryptPasswordPlaceholder": "Ingrese la contraseña de cifrado del backup",
        "decryptPasswordHelp": "La misma contraseña usada al cifrar el backup",
        "noPasswordForSql": "Los archivos .sql no requieren contraseña (ej.: importación de otro panel o backup sin cifrado).",
        "automaticBackup": "Backup Automático",
        "createNow": "Hacer Backup Ahora",
        "creating": "Creando backup...",
        "confirmCreate": "¿Desea crear un backup manual ahora?\n\nEl backup se guardará en el servidor.",
        "createBackupTitle": "Crear Backup Manual",
        "createSuccess": "¡Backup creado con éxito!",
        "createError": "Error al crear backup",
        "dragFile": "Arrastre el archivo aquí o haga clic para seleccionar",
        "confirmRestore": "Confirmo que deseo BORRAR todos los datos actuales.",
        "confirmRestoreDesc": "Esta acción no se puede deshacer.",
        "confirmRestoreFinal": "CONFIRMACIÓN FINAL\n\nTodos los datos actuales serán ELIMINADOS PERMANENTEMENTE.\n\n¿Desea continuar?",
        "restoreWarning": "⚠️ Confirmar Restauración",
        "restore": "Restaurar Backup",
        "restoring": "Restaurando...",
        "restoreSuccess": "¡Backup restaurado con éxito! Será desconectado.",
        "restoreError": "Error al restaurar backup",
        "encryptionPassword": "Contraseña de Cifrado",
        "encryptionPasswordPlaceholder": "Ingrese la contraseña para cifrar los backups (mínimo 8 caracteres)",
        "encryptionPasswordHelp": "Contraseña usada para cifrar los archivos de backup. ¡Guárdela de forma segura! Será necesaria para restaurar.",
        "criticalOperationTitle": "⚠️ OPERACIÓN CRÍTICA",
        "criticalOperationItem1": "Esta operación BORRARÁ todos los datos actuales",
        "criticalOperationItem2": "Haga un backup antes de restaurar",
        "criticalOperationItem3": "Será desconectado después de la restauración",
        "restoreProgressWait": "Espere. Esta operación puede tardar unos minutos. No cierre esta página."
      },
      "cleanup": {
        "title": "Limpieza Automática",
        "enableCleanup": "Habilitar Limpieza de Dispositivos",
        "enableCleanupDesc": "Elimina dispositivos inactivos automáticamente",
        "minutes": "Inactividad (minutos)",
        "minutesDesc": "Eliminar después de cuántos minutos sin acceso"
      },
      "advanced": {
        "title": "Avanzado",
        "maintenanceMode": "Modo Mantenimiento",
        "maintenanceModeDesc": "Deshabilita acceso al panel (solo super admin)",
        "autoSales": "Ventas Automáticas Globales",
        "autoSalesDesc": "Habilita ventas automáticas para todos los admins"
      },
      "templates": {
        "title": "Plantillas de Mensajes",
        "description": "Personaliza mensajes al crear cuentas, revendedores, pruebas y ventas automáticas. Usa variables para datos dinámicos y {br} para saltos de línea entre bloques.",
        "accountLabel": "Mensaje de Cuenta",
        "resellerLabel": "Mensaje de Revendedor",
        "testLabel": "Mensaje de Cuenta de Prueba",
        "whatsappFormat": "Formato WhatsApp",
        "telegramFormat": "Formato Telegram",
        "salesSectionTitle": "Ventas automáticas (página pública)",
        "salesSectionDesc": "Una plantilla por tipo — usada en «Copiar credenciales» tras el pago PIX.",
        "salesAccountLabel": "Mensaje de cuenta (ventas)",
        "salesResellerLabel": "Mensaje de revendedor (ventas)",
        "availableVars": "Variables disponibles (clic para insertar):",
        "formattingVarsHint": "Use {br} para una línea en blanco entre bloques. Las líneas vacías en el editor también funcionan. Los campos vacíos (Tienda, App, etc.) se omiten automáticamente.",
        "resetDefault": "Restaurar predeterminado",
        "preview": "Vista previa",
        "previewWhatsapp": "Vista previa WhatsApp",
        "previewTelegram": "Vista previa Telegram",
        "previewPlain": "Vista previa (texto simple)",
        "appLinkLabel": "Enlace de la app",
        "appLinkHint": "Se usa en {app_link} en todos los templates. Si está vacío, se omite la línea del app.",
        "appLinkPlaceholder": "https://play.google.com/store/apps/details?id=...",
        "customizedBadge": "Personalizado",
        "inheritedFromMaster": "Heredado de {name}",
        "inheritedFromGlobal": "Heredado del panel global",
        "clearCustomization": "Limpiar personalización",
        "clearCustomizationSuccess": "Personalización eliminada — heredando del master de nuevo.",
        "clearCustomizationLocal": "Cambios locales descartados — valor heredado restaurado.",
        "editorHint": "El texto predeterminado ya está rellenado para que pueda editarlo. Use «Restaurar predeterminado» para volver a la plantilla original del sistema."
      },
      "unsavedChanges": "Tienes cambios sin guardar",
      "saveSuccess": "¡Configuraciones guardadas con éxito!",
      "saveError": "Error al guardar configuraciones",
      "changesDiscarded": "Cambios descartados",
      "uploadSuccess": "¡Archivo subido con éxito!",
      "uploadError": "Error al subir archivo",
      "removeIcon": "Eliminar Ícono",
      "removeIconConfirm": "¿Estás seguro? Se usará el ícono predeterminado.",
      "removeSuccess": "Ícono eliminado con éxito"
    },
    "pwa": {
      "installTitle": "Instalar App",
      "manualInstallToastTitle": "Instalación manual",
      "manualInstallToast": "Menú del navegador (⋮) → Instalar / Aplicación / Instalar esta página.",
      "manualInstallHint": "Sin diálogo automático: en Chrome o Edge abre el menú (⋮) y elige Instalar o «Instalar como aplicación» / «Instalar esta página». Otros navegadores pueden usar el menú lateral o Compartir.",
      "httpsHint": "En escritorio se requiere HTTPS en producción (localhost es excepción).",
      "installMessage": "Instala Veltrix Panel como aplicación",
      "installButton": "Instalar Ahora",
      "installing": "Instalando...",
      "benefit1": "Acceso rápido sin abrir navegador",
      "benefit2": "Funciona sin conexión",
      "benefit3": "Notificaciones en tiempo real",
      "updateTitle": "Actualización disponible",
      "updateMessage": "Una nueva versión está lista para instalarse",
      "updateButton": "Actualizar Ahora"
    }
  },
  "messageTemplates": {
    "copyWhatsapp": "Copiar (WhatsApp)",
    "copyTelegram": "Copiar (Telegram)",
    "copied": "¡Copiado!",
    "copySuccess": "¡Mensaje copiado!",
    "copyError": "Error al copiar",
    "emptyTemplate": "Configure la plantilla en Configuración → Mensajes."
  },
  "auditUserTypes": {
    "super_admin": "Super Admin",
    "admin": "Admin",
    "reseller": "Revendedor",
    "sub_reseller": "Sub-revendedor",
    "system": "Sistema",
    "info": "Info",
    "warning": "Advertencia",
    "error": "Error",
    "critical": "Crítico"
  },
  "auditEntities": {
    "users": "Cuenta",
    "resellers": "Revendedor",
    "categories": "Categoría",
    "servers": "Servidor",
    "payments": "Pago",
    "panel_settings": "Configuración",
    "admin_users": "Administrador",
    "device_ids": "Dispositivos",
    "system": "Sistema"
  },
  "auditActions": {
    "payment_created": "Pago creado",
    "setting_updated": "Configuración actualizada",
    "settings_bulk_updated": "Configuraciones en lote",
    "server_created": "Servidor creado",
    "server_updated": "Servidor actualizado",
    "server_deleted": "Servidor eliminado",
    "automation_toggled": "Automatización alternada",
    "reseller_created": "Revendedor creado",
    "reseller_updated": "Revendedor actualizado",
    "reseller_deleted": "Revendedor eliminado",
    "reseller_credits_returned": "Créditos devueltos",
    "reseller_credits_added": "Créditos agregados",
    "reseller_credits_deducted": "Créditos deducidos",
    "reseller_credit_deducted": "Crédito descontado (pago)",
    "reseller_slots_returned": "Slots devueltos",
    "reseller_subscription_renewed": "Suscripción renovada",
    "reseller_hierarchy_deactivated": "Jerarquía desactivada",
    "reseller_hierarchy_activated": "Jerarquía reactivada",
    "reseller_created_via_payment": "Revenda vía pago",
    "reseller_renewed_via_payment": "Renovación vía pago",
    "reseller_credits_purchased": "Créditos comprados",
    "account_created": "Cuenta creada",
    "account_created_from_plan": "Cuenta vía plan",
    "account_updated": "Cuenta actualizada",
    "account_deleted": "Cuenta eliminada",
    "account_renewed": "Cuenta renovada",
    "account_status_toggled": "Estado de cuenta",
    "category_created": "Categoría creada",
    "category_updated": "Categoría actualizada",
    "category_deleted": "Categoría eliminada",
    "category_set_default": "Categoría predeterminada",
    "category_migration": "Migración de categorías",
    "branding_updated": "Branding actualizado",
    "branding_deleted": "Branding eliminado",
    "branding_settings_updated": "Branding (ajustes)",
    "devices_cleanup": "Limpieza de dispositivos",
    "admin_login": "Inicio de sesión",
    "admin_logout": "Cierre de sesión",
    "admin_created": "Admin creado",
    "failed_login_attempt": "Inicio fallido",
    "worker_backup_success": "Respaldo automático",
    "worker_backup_error": "Respaldo automático (error)",
    "worker_device_cleanup": "Limpieza de dispositivos",
    "worker_device_cleanup_error": "Limpieza de dispositivos (error)",
    "worker_check_expired": "Verificación de expirados",
    "worker_check_expired_error": "Verificación de expirados (error)"
  },
  "auditMessages": {
    "genericWithEntity": "{action} — {entity}",
    "payment_created": "Pago #{entityId} registrado",
    "setting_updated": "Configuración del panel modificada",
    "settings_bulk_updated": "Varias configuraciones actualizadas",
    "server_created": "Servidor #{entityId} creado",
    "server_updated": "Servidor #{entityId} actualizado",
    "server_deleted": "Servidor #{entityId} eliminado",
    "automation_toggled": "Estado de automatización cambiado",
    "reseller_created": "Revendedor #{entityId} creado",
    "reseller_updated": "Revendedor #{entityId} actualizado",
    "reseller_deleted": "Revendedor #{entityId} eliminado",
    "reseller_credits_returned": "{credits_returned} crédito(s) devuelto(s) al revendedor padre",
    "reseller_credits_added": "+{amount} crédito(s); saldo: {new_balance}",
    "reseller_credits_deducted": "Créditos deducidos del revendedor #{entityId}",
    "reseller_credit_deducted": "Descuento de R$ {amount} — {detail}",
    "reseller_slots_returned": "{slots_returned} slot(s) devuelto(s)",
    "reseller_subscription_renewed": "Suscripción del revendedor #{entityId} renovada",
    "reseller_hierarchy_deactivated": "Revendedor #{entityId} y red desactivados",
    "reseller_hierarchy_activated": "Revendedor #{entityId} y red reactivados",
    "reseller_created_via_payment": "Sub-revendedor {username} creado vía PIX (tipo: {type})",
    "reseller_renewed_via_payment": "Revendedor #{resellerId} renovado (+{days} días, límite {limit})",
    "reseller_credits_purchased": "Revendedor #{resellerId}: +{credits} crédito(s); saldo {balance}",
    "account_created": "Cuenta {username} creada",
    "account_created_from_plan": "Cuenta creada desde plan (ID {entityId})",
    "account_updated": "Cuenta #{entityId} actualizada",
    "account_deleted": "Cuenta #{entityId} eliminada",
    "account_renewed": "Cuenta #{entityId} renovada",
    "account_status_toggled": "Estado de la cuenta #{entityId} cambiado",
    "category_created": "Categoría creada (ID {entityId})",
    "category_updated": "Categoría #{entityId} actualizada",
    "category_deleted": "Categoría #{entityId} eliminada",
    "category_set_default": "Categoría #{entityId} definida como predeterminada",
    "category_migration": "Cuentas migradas entre categorías",
    "branding_updated": "Icono o imagen de branding actualizado",
    "branding_deleted": "Elemento de branding eliminado (tipo: {type})",
    "branding_settings_updated": "Ajustes de branding guardados",
    "devices_cleanup": "{count} dispositivo(s) eliminado(s) en limpieza manual",
    "admin_login": "Sesión iniciada",
    "admin_logout": "Sesión cerrada",
    "admin_created": "Nuevo administrador (ID {entityId})",
    "failed_login_attempt": "Intento de inicio fallido para \"{username}\" (IP {ip})",
    "worker_check_expired": "{expired_accounts} cuenta(s) y {expired_resellers} revendedor(es) expirados; {slots_returned} slot(s) devuelto(s)",
    "worker_check_expired_error": "Fallo en verificación de expirados: {error}",
    "worker_device_cleanup": "{devices_deleted} dispositivo(s) eliminado(s)",
    "worker_device_cleanup_error": "Fallo en limpieza de dispositivos: {error}",
    "worker_backup_success": "Respaldo {filename} completado ({size_mb} MB)",
    "worker_backup_error": "Fallo en respaldo automático: {error}"
  },
  "auditDetails": {
    "account_created_via_pix": "cuenta creada vía pago PIX"
  },
  "install": {
    "subtitle": "Asistente de Instalación",
    "toggle_theme": "Alternar tema claro/oscuro",
    "lang_change_later": "Puedes cambiar el idioma después en configuración",
    "step_language": "Idioma",
    "step_language_desc": "Selecciona el idioma del panel",
    "step_requirements": "Requisitos",
    "step_requirements_desc": "Verificación de los requisitos del sistema",
    "step_database": "Base de Datos",
    "step_database_desc": "Configura la conexión con MySQL",
    "step_admin": "Administrador",
    "step_admin_desc": "Crea la cuenta de administrador",
    "step_install": "Instalación",
    "step_install_desc": "Ejecución de la instalación del sistema",
    "step_of": "Paso {current} de {total}",
    "req_api": "API Backend Accesible",
    "db_host": "Host de la Base de Datos",
    "db_user": "Usuario de la Base de Datos",
    "db_password": "Contraseña de la Base de Datos",
    "db_name": "Nombre de la Base de Datos",
    "test_connection": "Probar Conexión",
    "testing": "Probando...",
    "connection_error": "Error al conectar con la base de datos",
    "admin_user": "Usuario Admin",
    "admin_email": "Correo Admin",
    "admin_password": "Contraseña Admin",
    "admin_confirm": "Confirmar Contraseña",
    "passwords_mismatch": "Las contraseñas no coinciden",
    "back": "Volver",
    "next": "Siguiente",
    "install_now": "Instalar Ahora",
    "processing": "Procesando...",
    "progress": "Progreso",
    "log_starting": "Iniciando instalación...",
    "log_connecting": "Conectando a la base de datos...",
    "log_schemas": "Ejecutando esquemas de la base de datos...",
    "log_done": "¡Instalación completada con éxito!",
    "log_error": "Error durante la instalación",
    "success_title": "¡Instalación Completada!",
    "success_message": "El sistema se instaló correctamente. Ya puedes iniciar sesión.",
    "go_to_login": "Ir al Login",
    "retry": "Intentar de Nuevo"
  },
  "viewMessages": {
    "profile": {
      "invalidFormat": "Formato inválido. Use JPG o PNG",
      "fileTooLarge": "Archivo demasiado grande. Máximo: {max} MB al elegir.",
      "imageTooLarge": "Imagen demasiado grande. Máximo: 512x512 píxeles",
      "avatarUpdatedSuccess": "¡Avatar actualizado con éxito!",
      "avatarRemovedSuccess": "¡Avatar eliminado con éxito!",
      "uploadError": "Error al subir",
      "removeAvatarError": "Error al eliminar avatar",
      "enterPassword": "¡Ingrese la nueva contraseña!",
      "passwordMismatch": "¡Las contraseñas no coinciden!",
      "passwordChangeSuccess": "¡Contraseña cambiada con éxito!",
      "enterCurrentPassword": "¡Ingrese su contraseña actual para cambiarla!",
      "confirmRemoveAvatar": "¿Está seguro de que desea eliminar su foto de perfil?",
      "updateProfileError": "Error al actualizar perfil"
    },
    "backup": {
      "configureTelegram": "Configure el bot de Telegram y guarde la configuración",
      "autoBackupDisabled": "Copia de seguridad automática desactivada",
      "enterBotToken": "Ingrese el Bot Token",
      "enterChatId": "Ingrese el Chat ID",
      "configureEncryptionPassword": "Configure una contraseña de cifrado (mínimo 8 caracteres)",
      "encryptionPasswordTooShort": "La contraseña de cifrado debe tener al menos 8 caracteres",
      "configSavedSuccess": "¡Configuración de copia de seguridad guardada con éxito!",
      "configSaveError": "Error al guardar la configuración de copia de seguridad",
      "backupStarted": "¡Copia de seguridad iniciada! Recibirá el archivo en Telegram en breve.",
      "backupError": "Error al ejecutar copia de seguridad",
      "selectValidEncFile": "Por favor, seleccione un archivo .enc válido",
      "restoreSuccess": "¡Copia de seguridad restaurada con éxito!\n\nSerá desconectado. Inicie sesión nuevamente.",
      "restoreError": "Error al restaurar copia de seguridad",
      "confirmBackupTitle": "¿Ejecutar Copia de Seguridad Ahora?",
      "confirmBackupMessage": "Se generará una copia de seguridad completa de la base de datos y se enviará al Telegram configurado. ¿Desea continuar?",
      "confirmRestoreTitle": "⚠️ RESTAURAR COPIA DE SEGURIDAD",
      "confirmRestoreMessage": "ATENCIÓN: Todos los datos actuales serán REEMPLAZADOS por los datos de la copia de seguridad. Esta acción NO puede deshacerse. ¿Desea continuar?",
      "passwordNotConfigured": "⚠️ ¡Contraseña de copia de seguridad no configurada!\n\nPor favor, configure la contraseña de cifrado arriba y guarde la configuración antes de hacer la copia de seguridad.",
      "incompleteConfiguration": "❌ ¡Configuración incompleta!\n\n{error}\n\nPor favor, verifique la configuración anterior e inténtelo de nuevo.",
      "noBackupRun": "Ninguna copia de seguridad realizada",
      "confirmManualBackupTitle": "Confirmar Copia de Seguridad Manual",
      "confirmManualBackupMessage": "¿Desea hacer una copia de seguridad manual ahora?\n\nLa copia de seguridad será cifrada y enviada a Telegram."
    },
    "branding": {
      "loadingError": "Error al cargar configuración de marca",
      "iconUpdatedSuccess": "¡Ícono actualizado con éxito!",
      "iconSizesGenerated": "¡{count} tamaños generados automáticamente!",
      "iconUploadError": "Error al subir el ícono",
      "iconRemovedSuccess": "¡Ícono eliminado con éxito!",
      "iconRemoveError": "Error al eliminar ícono",
      "pwaUpdatedSuccess": "¡Configuraciones PWA actualizadas!",
      "pwaUpdateError": "Error al actualizar configuraciones PWA"
    },
    "dashboard": {
      "statsLoadError": "Error al cargar estadísticas del panel",
      "categoriesLoadError": "Error al cargar categorías"
    },
    "accounts": {
      "loadError": "Error al cargar cuentas",
      "categoriesLoadError": "Error al cargar categorías",
      "statusUpdated": "¡Estado actualizado!",
      "deleteSuccess": "¡Cuenta eliminada con éxito!",
      "bulkDeleteSuccess": "¡{deleted} de {total} cuenta(s) eliminada(s) con éxito!",
      "bulkDeleteNone": "No se eliminó ninguna cuenta",
      "devicesRemovedSuccess": "¡Dispositivos eliminados con éxito!",
      "enterNewPassword": "Ingrese una nueva contraseña para actualizar",
      "updateSuccess": "¡Cuenta actualizada con éxito!",
      "loadDetailsError": "Error al cargar detalles de la cuenta",
      "credentialsCopied": "¡Credenciales copiadas!",
      "expiredBeforeEnable": "¡Cuenta expirada! Renueve antes de activar.",
      "createError": "Error al crear cuenta",
      "createTestError": "Error al crear cuenta de prueba",
      "minDaysError": "La validez mínima es {min} días",
      "selectPlanAndCategory": "Seleccione un plan y una categoría",
      "insufficientCreditsPlan": "¡Créditos insuficientes! Tiene {available}, necesita {needed} para este plan ({days} días)",
      "insufficientCreditsMonths": "¡Créditos insuficientes! Tiene {available}, necesita {needed}",
      "statusUpdateError": "Error al actualizar estado",
      "deleteError": "Error al eliminar cuenta",
      "bulkDeleteError": "Error al eliminar algunas cuentas",
      "clearDevicesError": "Error al limpiar dispositivos",
      "copyCredentialsError": "Error al copiar credenciales",
      "accountNotFound": "Cuenta no encontrada",
      "buildMessageError": "No se pudo construir el mensaje",
      "selectCategory": "Seleccione una categoría"
    },
    "accountPlans": {
      "loadError": "Error al cargar planes",
      "createSuccess": "¡Plan creado con éxito!",
      "updateSuccess": "¡Plan actualizado con éxito!",
      "deleteSuccess": "¡Plan eliminado con éxito!",
      "saveError": "Error al guardar plan",
      "deleteError": "Error al eliminar plan"
    },
    "resellers": {
      "creditsAddedSuccess": "¡Créditos agregados con éxito!",
      "subscriptionAdjustedSuccess": "¡Suscripción ajustada con éxito!",
      "processError": "Error al procesar operación",
      "deleteSuccess": "¡Revendedor eliminado con éxito!",
      "deleteError": "Error al eliminar revendedor",
      "fillRequiredFields": "Complete usuario, correo electrónico y contraseña",
      "loadError": "Error al cargar revendedores",
      "statusUpdated": "¡Estado actualizado!",
      "statusUpdateError": "Error al cambiar estado",
      "bulkDeleteSuccess": "¡{count} revendedor(es) eliminado(s) con éxito!",
      "bulkDeleteError": "Error al eliminar algunos revendedores"
    },
    "resellerPlans": {
      "loadError": "Error al cargar planes",
      "deleteSuccess": "¡Plan eliminado con éxito!",
      "deleteError": "Error al eliminar plan"
    },
    "checkuser": {
      "statsLoadError": "Error al cargar estadísticas del CheckUser",
      "configSaved": "¡Configuraciones guardadas con éxito!",
      "urlCopied": "¡URL copiada!",
      "endpointResponding": "¡Endpoint {name} respondiendo! ✅\n\n{details}",
      "endpointProblem": "Endpoint {name} con problema:\n\n{details}",
      "endpointTestError": "Error al probar endpoint: {error}",
      "devicesRemovedSuccess": "¡Dispositivos eliminados con éxito!",
      "cleanupManualSuccess": "Limpieza completada: {removed} dispositivo(s) eliminado(s).",
      "cleanupManualError": "Error al ejecutar la limpieza manual.",
      "configSaveError": "Error al guardar la configuración.",
      "devicesClearError": "Error al limpiar dispositivos."
    },
    "settings": {
      "loadError": "Error al cargar configuraciones"
    },
    "logs": {
      "loadError": "Error al cargar registros",
      "logsCleared": "¡{count} registro(s) eliminado(s)!",
      "clearError": "Error al limpiar registros"
    },
    "automations": {
      "selectPaymentMethodsWarning": "Seleccione al menos un método de pago",
      "paymentMethodsUpdatedSuccess": "Métodos de pago actualizados con éxito",
      "paymentMethodsSaveError": "Error al guardar métodos de pago",
      "urlCopied": "¡URL copiada!",
      "categorySaveError": "Error al guardar categoría",
      "featureDisabled": "Desactivado",
      "featureEnabledWithUrl": "¡Activado! URL: {url}",
      "updateError": "Error al actualizar",
      "goToAccountPlansTitle": "¿Ir a Planes de Cuenta?",
      "goToResellerPlansTitle": "¿Ir a Planes de Revendedor?",
      "deleteGatewayConfirm": "¿Está seguro de que desea eliminar este gateway?",
      "deleteGatewayTitle": "Eliminar Gateway",
      "gatewayRemoved": "¡Gateway eliminado!",
      "gatewayRemoveError": "Error al eliminar gateway",
      "gatewayUpdatedSuccess": "¡Gateway y métodos actualizados!",
      "gatewayAddedSuccess": "¡Gateway agregado! Haga clic en \"Configurar Métodos\" para seleccionar formas de pago.",
      "gatewaySaveError": "Error al guardar gateway"
    },
    "auth": {
      "loginFallbackError": "Error al iniciar sesión. Verifique sus credenciales."
    },
    "payment": {
      "usernameValidation": "El nombre de usuario debe tener 3-32 caracteres (solo letras y números)",
      "createPaymentError": "Error al crear el pago. Inténtelo de nuevo."
    },
    "servers": {
      "loadError": "Error al cargar servidores: {error}",
      "categoriesLoadWarning": "No se pudieron cargar categorías. Usando categoría predeterminada.",
      "createSuccess": "¡Servidor agregado con éxito!",
      "createError": "Error al agregar servidor",
      "createErrorWithTips": "{message}\n\n💡 Consejos:\n{tips}",
      "invalidApiPort": "Puerto de API inválido. Debe estar entre 1024 y 65535",
      "duplicateServer": "Ya existe un servidor con esta IP y puerto",
      "updateSuccess": "¡Servidor actualizado con éxito!",
      "updateError": "Error al actualizar servidor",
      "apiOnlineSuccess": "¡La API está en línea y funcionando!",
      "apiNotResponding": "La API no responde",
      "apiNotInstalledInfo": "La API no está instalada",
      "apiStatusCheckError": "Error al verificar el estado de la API",
      "deleteSuccess": "¡Servidor eliminado con éxito!",
      "deleteError": "Error al eliminar servidor",
      "apiUninstalledBeforeDelete": "API desinstalada antes de la eliminación",
      "deleteContinueDespiteApiError": "Continuando eliminación a pesar del error al desinstalar la API",
      "apiUninstallSuccess": "¡API desinstalada con éxito!",
      "apiUninstallError": "Error al desinstalar API",
      "ssh2ExtensionError": "La extensión SSH2 no está instalada.\n\n{instructions}\n\n{note}",
      "unknownError": "Error desconocido"
    },
    "categories": {
      "loadError": "Error al cargar categorías",
      "createSuccess": "Categoría creada con éxito",
      "updateSuccess": "Categoría actualizada con éxito",
      "saveError": "Error al guardar categoría",
      "alreadyDefault": "Esta categoría ya es la predeterminada",
      "setDefaultSuccess": "¡Categoría \"{name}\" definida como predeterminada!",
      "setDefaultError": "Error al definir categoría predeterminada",
      "migrateSuccess": "¡{count} {entity} migrados con éxito!",
      "migrateError": "Error al migrar",
      "deleteSuccess": "Categoría eliminada con éxito"
    },
    "coupons": {
      "loadError": "Error al cargar cupones",
      "createSuccess": "¡Cupón creado!",
      "updateSuccess": "¡Cupón actualizado!",
      "saveError": "Error al guardar cupón",
      "deactivated": "Cupón desactivado",
      "activated": "Cupón activado",
      "toggleError": "Error al actualizar cupón",
      "deleteSuccess": "¡Cupón eliminado!",
      "deleteError": "Error al eliminar cupón"
    }
  },
  "apiMessages": {
    "emailPasswordRequired": "Usuario/email y contraseña son obligatorios",
    "invalidCredentials": "Credenciales inválidas",
    "notAuthenticated": "No autenticado",
    "invalidToken": "Token inválido",
    "resellerInactive": "Su cuenta de revendedor está inactiva. Contacte al soporte.",
    "resellerExpired": "Su suscripción de revendedor ha expirado. Renueve para continuar.",
    "resellerNotFound": "Revendedor no encontrado",
    "loginSuccess": "Inicio de sesión exitoso",
    "logoutSuccess": "Cierre de sesión exitoso",
    "currentPasswordRequired": "La contraseña actual es obligatoria",
    "newPasswordRequired": "La nueva contraseña es obligatoria",
    "currentPasswordWrong": "La contraseña actual es incorrecta",
    "passwordChanged": "Contraseña cambiada con éxito",
    "noFileUploaded": "Ningún archivo enviado o error en la carga",
    "fileTooLarge": "Archivo demasiado grande. Máximo: 3MB después del recorte",
    "fileTooLarge3mb": "Archivo demasiado grande. Máximo: 3MB después del recorte",
    "invalidFileType": "Tipo de archivo inválido. Use JPG o PNG",
    "imageProcessingError": "Error al procesar la imagen",
    "imageTooLarge": "Imagen demasiado grande. Máximo: 512x512 píxeles",
    "avatarUpdated": "Avatar actualizado con éxito",
    "avatarRemoved": "Avatar eliminado con éxito",
    "accountCreated": "Cuenta creada con éxito",
    "accountUpdated": "Cuenta actualizada con éxito",
    "accountDeleted": "Cuenta eliminada con éxito",
    "accountRenewed": "Cuenta renovada con éxito",
    "accountCreatedFromPlan": "Cuenta creada a partir del plan",
    "planCategoryRequired": "Los campos plan_id y category_id son obligatorios",
    "noValidIds": "No se proporcionaron IDs válidos",
    "errorListingAccounts": "Error al listar cuentas",
    "errorUpdatingAccount": "Error al actualizar cuenta",
    "errorDeletingAccount": "Error al eliminar cuenta",
    "planCreated": "Plan creado con éxito",
    "planUpdated": "Plan actualizado con éxito",
    "planDeleted": "Plan eliminado con éxito",
    "noPermissionEditPlan": "No tiene permiso para editar este plan",
    "noPermissionDeletePlan": "No tiene permiso para eliminar este plan",
    "resellerNoCategory": "El revendedor no tiene una categoría vinculada",
    "errorFetchingData": "Error al obtener datos",
    "usernameInvalid": "El nombre de usuario debe tener 3-50 caracteres alfanuméricos",
    "emailInvalid": "Correo electrónico inválido",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
    "usernameExists": "El nombre de usuario ya existe",
    "emailExists": "El correo electrónico ya está registrado",
    "adminCreated": "Administrador creado con éxito",
    "adminUpdated": "Administrador actualizado con éxito",
    "adminDeleted": "Administrador eliminado con éxito",
    "cannotChangeSuperAdmin": "No se puede cambiar el rol de super_admin",
    "cannotDeleteSuperAdmin": "No se puede eliminar super_admin",
    "cannotDeleteSelf": "No puede eliminar su propia cuenta",
    "cannotDeactivateSelf": "No puede desactivar su propia cuenta",
    "cannotDeactivateSuperAdmin": "No se puede desactivar super_admin",
    "errorListingAdmins": "Error al listar administradores",
    "couponCodeRequired": "El código del cupón es obligatorio",
    "invalidDiscount": "Descuento inválido",
    "couponExists": "Ya existe un cupón con este código",
    "couponCreated": "Cupón creado con éxito",
    "couponInvalid": "Cupón inválido o expirado",
    "usernameRequired": "Nombre de usuario obligatorio",
    "usernameOrEmailExists": "El usuario o email ya existe",
    "serverCreated": "Servidor creado con éxito",
    "serverUpdated": "Servidor actualizado con éxito",
    "serverDeleted": "Servidor eliminado con éxito",
    "syncStarted": "Sincronización iniciada. Se le notificará cuando termine.",
    "invalidServerId": "ID de servidor inválido",
    "userNotIdentified": "Usuario no identificado",
    "serverNotFound": "Servidor no encontrado",
    "jobNotFound": "Tarea no encontrada o expirada",
    "jobIdRequired": "job_id es obligatorio",
    "categoryCreated": "Categoría creada con éxito",
    "categoryUpdated": "Categoría actualizada con éxito",
    "categoryDeleted": "Categoría eliminada con éxito",
    "settingsSaved": "Configuraciones guardadas con éxito",
    "backupSuccess": "Respaldo realizado con éxito",
    "resellerCreated": "Revendedor creado con éxito",
    "resellerUpdated": "Revendedor actualizado con éxito",
    "resellerDeleted": "Revendedor eliminado con éxito",
    "testAccountCreated": "Cuenta de prueba creada con éxito",
    "subscriptionExpired": "Su suscripción ha expirado. Renueve para continuar.",
    "userNotFound": "Usuario no encontrado",
    "resellersOnly": "Solo revendedores",
    "error": "Error",
    "accountStatusIs": "Su cuenta tiene un estado irregular. Contacte al soporte.",
    "resellerAccountStatusIs": "Su cuenta de revendedor tiene un estado irregular. Contacte al soporte.",
    "resellerExpiredAt": "Su suscripción de revendedor ha expirado. Renueve para continuar creando cuentas.",
    "noCreditsAvailable": "Sin créditos disponibles.",
    "loginLimitReached": "Límite de inicios de sesión alcanzado.",
    "noServersInCategory": "No se encontraron servidores en la categoría seleccionada.",
    "errorDeletingAccounts": "Error al eliminar cuentas.",
    "loginError": "Error de inicio de sesión.",
    "errorFetchingUser": "Error al obtener usuario.",
    "errorRenewingToken": "Error al renovar token.",
    "errorUpdatingProfile": "Error al actualizar perfil.",
    "errorListingPlans": "Error al listar planes.",
    "invalidIds": "IDs inválidos.",
    "creditResellerRestriction": "Los revendedores tipo crédito tienen restricciones de edición.",
    "enterNewPassword": "Ingrese una nueva contraseña o WhatsApp para actualizar."
  }
}
